<template>
  <MainLayout>
    <template #content>
      <div class="content-container flex flex-col w-full px-8 py-8">
        <div class="prose max-w-none text-sm leading-6">
          <h1 class="text-2xl font-semibold mb-4">Datenschutz</h1>
          <h2 class="text-lg font-semibold mt-6 mb-2">Eingebettete Social Media Elemente Datenschutzerklärung</h2>
          <p>
            Wir binden auf unserer Webseite Elemente von Social Media Diensten ein um Bilder, Videos und Texte
            anzuzeigen.
          </p>
          <p>
            Durch den Besuch von Seiten die diese Elemente darstellen, werden Daten von Ihrem Browser zum jeweiligen
            Social Media Dienst übertragen und dort gespeichert. Wir haben keinen Zugriff auf diese Daten.
          </p>
          <p>
            Die folgenden Links führen Sie zu den Seiten der jeweiligen Social Media Dienste wo erklärt wird, wie diese
            mit Ihren Daten umgehen:
          </p>
          <p>
            Instagram-Datenschutzrichtlinie:
            <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer"
              >https://help.instagram.com/519522125107875</a
            >
          </p>
          <p>
            Für YouTube gilt die Google Datenschutzerklärung:
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer"
              >https://policies.google.com/privacy?hl=de</a
            >
          </p>
          <p>
            Facebook-Datenrichtline:
            <a href="https://www.facebook.com/about/privacy" target="_blank" rel="noopener noreferrer"
              >https://www.facebook.com/about/privacy</a
            >
          </p>
          <p>
            Twitter Datenschutzrichtlinie:
            <a href="https://twitter.com/de/privacy" target="_blank" rel="noopener noreferrer"
              >https://twitter.com/de/privacy</a
            >
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Datenschutz</h2>
          <p>
            Wir haben diese Datenschutzerklärung (Fassung 05.06.2020-221128197) verfasst, um Ihnen gemäß der Vorgaben
            der
            <a href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=221128197"
              >Datenschutz-Grundverordnung (EU) 2016/679</a
            >
            zu erklären, welche Informationen wir sammeln, wie wir Daten verwenden und welche Entscheidungsmöglichkeiten
            Sie als Besucher dieser Webseite haben.
          </p>
          <p>
            Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir haben uns bei der
            Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu beschreiben.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Automatische Datenspeicherung</h2>
          <p>
            Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und gespeichert,
            so auch auf dieser Webseite.
          </p>
          <p>
            Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem diese
            Webseite gespeichert ist) automatisch Daten wie
          </p>
          <ul>
            <li>die Adresse (URL) der aufgerufenen Webseite</li>
            <li>Browser und Browserversion</li>
            <li>das verwendete Betriebssystem</li>
            <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
            <li>den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird</li>
            <li>Datum und Uhrzeit</li>
          </ul>
          <p>in Dateien (Webserver-Logfiles).</p>
          <p>
            In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht. Wir geben
            diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von
            rechtswidrigem Verhalten eingesehen werden.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Cookies</h2>
          <p>Unsere Webseite verwendet HTTP-Cookies, um nutzerspezifische Daten zu speichern.</p>
          <p>
            Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende
            Datenschutzerklärung besser verstehen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was genau sind Cookies?</h3>
          <p>
            Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind beispielsweise
            Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten Webseiten speichern kleine
            Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies.
          </p>
          <p>
            Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein. Fast alle Webseiten
            verwenden Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere Cookies für andere
            Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von unserer Webseite auf Ihrem Computer
            gespeichert werden. Diese Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem „Hirn“ Ihres
            Browsers, untergebracht. Ein Cookie besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies
            müssen zusätzlich ein oder mehrere Attribute angegeben werden.
          </p>
          <p>
            Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache oder persönliche
            Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen, übermittelt Ihr Browser die „userbezogenen“
            Informationen an unsere Seite zurück. Dank der Cookies weiß unsere Webseite, wer Sie sind und bietet Ihnen
            die Einstellung, die Sie gewohnt sind. In einigen Browsern hat jedes Cookie eine eigene Datei, in anderen
            wie beispielsweise Firefox sind alle Cookies in einer einzigen Datei gespeichert.
          </p>
          <p>
            Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies. Erstanbieter-Cookies werden direkt von
            unserer Seite erstellt, Drittanbieter-Cookies werden von Partner-Webseiten (z.B. Google Analytics) erstellt.
            Jedes Cookie ist individuell zu bewerten, da jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines
            Cookies variiert von ein paar Minuten bis hin zu ein paar Jahren. Cookies sind keine Software-Programme und
            enthalten keine Viren, Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf Informationen Ihres
            PCs zugreifen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">So können zum Beispiel Cookie-Daten aussehen:</h3>
          <p>Name: _ga</p>
          <p>Wert: GA1.2.1326744211.152221128197-6</p>
          <p>Verwendungszweck: Unterscheidung der Webseitenbesucher</p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <h3 class="text-base font-semibold mt-6 mb-2">Diese Mindestgrößen sollte ein Browser unterstützen können:</h3>
          <ul>
            <li>Mindestens 4096 Bytes pro Cookie</li>
            <li>Mindestens 50 Cookies pro Domain</li>
            <li>Mindestens 3000 Cookies insgesamt</li>
          </ul>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Arten von Cookies gibt es?</h3>
          <p>
            Die Frage welche Cookies wir im Speziellen verwenden, hängt von den verwendeten Diensten ab und wird in den
            folgenden Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf die
            verschiedenen Arten von HTTP-Cookies eingehen.
          </p>
          <p>Man kann 4 Arten von Cookies unterscheiden:</p>
          <h3 class="text-base font-semibold mt-6 mb-2">Unerlässliche Cookies</h3>
          <p>
            Diese Cookies sind nötig, um grundlegende Funktionen der Webseite sicherzustellen. Zum Beispiel braucht es
            diese Cookies, wenn ein User ein Produkt in den Warenkorb legt, dann auf anderen Seiten weitersurft und
            später erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht gelöscht, selbst wenn der User sein
            Browserfenster schließt.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Zweckmäßige Cookies</h3>
          <p>
            Diese Cookies sammeln Infos über das Userverhalten und ob der User etwaige Fehlermeldungen bekommt. Zudem
            werden mithilfe dieser Cookies auch die Ladezeit und das Verhalten der Webseite bei verschiedenen Browsern
            gemessen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Zielorientierte Cookies</h3>
          <p>
            Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit. Beispielsweise werden eingegebene Standorte,
            Schriftgrößen oder Formulardaten gespeichert.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Werbe-Cookies</h3>
          <p>
            Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem User individuell angepasste Werbung
            zu liefern. Das kann sehr praktisch, aber auch sehr nervig sein.
          </p>
          <p>
            Üblicherweise werden Sie beim erstmaligen Besuch einer Webseite gefragt, welche dieser Cookiearten Sie
            zulassen möchten. Und natürlich wird diese Entscheidung auch in einem Cookie gespeichert.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie kann ich Cookies löschen?</h3>
          <p>
            Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig von welchem Service oder welcher
            Webseite die Cookies stammen, haben Sie immer die Möglichkeit Cookies zu löschen, zu deaktivieren oder nur
            teilweise zuzulassen. Zum Beispiel können Sie Cookies von Drittanbietern blockieren, aber alle anderen
            Cookies zulassen.
          </p>
          <p>
            Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden, wenn Sie
            Cookie-Einstellungen ändern oder löschen wollen, können Sie dies in Ihren Browser-Einstellungen finden:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie das Cookie erlauben oder nicht. Die Vorgangsweise ist je nach Browser verschieden. Am besten Sie
            suchen die Anleitung in Google mit dem Suchbegriff “Cookies löschen Chrome” oder „Cookies deaktivieren
            Chrome“ im Falle eines Chrome Browsers.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie sieht es mit meinem Datenschutz aus?</h3>
          <p>
            Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist festgehalten, dass das Speichern von
            Cookies eine Einwilligung des von Ihnen verlangt. Innerhalb der EU-Länder gibt es allerdings noch sehr
            unterschiedliche Reaktionen auf diese Richtlinien. In Österreich erfolgte aber die Umsetzung dieser
            Richtlinie in § 96 Abs. 3 des Telekommunikationsgesetzes (TKG).
          </p>
          <p>
            Wenn Sie mehr über Cookies wissen möchten und vor technischen Dokumentationen nicht zurückscheuen, empfehlen
            wir
            <a href="https://tools.ietf.org/html/rfc6265" target="_blank" rel="noopener noreferrer"
              >https://tools.ietf.org/html/rfc6265</a
            >, dem Request for Comments der Internet Engineering Task Force (IETF) namens „HTTP State Management
            Mechanism“.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Speicherung persönlicher Daten</h2>
          <p>
            Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum Beispiel Name,
            E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung eines Formulars oder
            Kommentaren im Blog, werden von uns gemeinsam mit dem Zeitpunkt und der IP-Adresse nur zum jeweils
            angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben.
          </p>
          <p>
            Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die Kontakt
            ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen Dienstleistungen und
            Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht weiter, können jedoch nicht ausschließen,
            dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.
          </p>
          <p>
            Wenn Sie uns persönliche Daten per E-Mail schicken – somit abseits dieser Webseite – können wir keine
            sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen, vertrauliche Daten niemals
            unverschlüsselt per E-Mail zu übermitteln.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Rechte laut Datenschutzgrundverordnung</h2>
          <p>
            Ihnen stehen laut den Bestimmungen der DSGVO und des
            <a
              href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=221128197"
              >österreichischen Datenschutzgesetzes (DSG)</a
            >
            grundsätzlich die folgende Rechte zu:
          </p>
          <ul class="my-2">
            <li>Recht auf Berichtigung (Artikel 16 DSGVO)</li>
            <li>Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
            <li>
              Recht auf Benachrichtigung – Mitteilungspflicht im Zusammenhang mit der Berichtigung oder Löschung
              personenbezogener Daten oder der Einschränkung der Verarbeitung (Artikel 19 DSGVO)
            </li>
            <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
            <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
            <li>
              Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung — einschließlich Profiling —
              beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)
            </li>
          </ul>
          <p>
            Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre
            datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der
            Aufsichtsbehörde beschweren, welche in Österreich die Datenschutzbehörde ist, deren Webseite Sie unter
            <a href="https://www.dsb.gv.at/" target="_blank" rel="noopener noreferrer">https://www.dsb.gv.at/</a>
            finden.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Auswertung des Besucherverhaltens</h2>
          <p>
            In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und wie wir Daten Ihres Besuchs dieser
            Website auswerten. Die Auswertung der gesammelten Daten erfolgt in der Regel anonym und wir können von Ihrem
            Verhalten auf dieser Website nicht auf Ihre Person schließen.
          </p>
          <p>
            Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu widersprechen erfahren Sie in der folgenden
            Datenschutzerklärung.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">TLS-Verschlüsselung mit https</h2>
          <p>
            Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch Technikgestaltung
            <a
              href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=221128197"
              target="_blank"
              rel="noopener noreferrer"
              >Artikel 25 Absatz 1 DSGVO</a
            >
            >). Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren
            Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die
            Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol links oben im Browser und der
            Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Google Maps Datenschutzerklärung</h2>
          <p>
            Wir benützen auf unserer Website Google Maps der Firma Google Inc. Für den europäischen Raum ist das
            Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
            verantwortlich. Mit Google Maps können wir Ihnen Standorte besser zeigen und damit unser Service an Ihre
            Bedürfnisse anpassen. Durch die Verwendung von Google Maps werden Daten an Google übertragen und auf den
            Google-Servern gespeichert. Hier wollen wir nun genauer darauf eingehen, was Google Maps ist, warum wir
            diesen Google-Dienst in Anspruch nehmen, welche Daten gespeichert werden und wie Sie dies unterbinden
            können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist Google Maps?</h3>
          <p>
            Google Maps ist ein Internet-Kartendienst der Firma Google. Mit Google Maps können Sie online über einen PC,
            ein Tablet oder eine App genaue Standorte von Städten, Sehenswürdigkeiten, Unterkünften oder Unternehmen
            suchen. Wenn Unternehmen auf Google My Business vertreten sind, werden neben dem Standort noch weitere
            Informationen über die Firma angezeigt. Um die Anfahrtsmöglichkeit anzuzeigen, können Kartenausschnitte
            eines Standorts mittels HTML-Code in eine Website eingebunden werden. Google Maps zeigt die Erdoberfläche
            als Straßenkarte oder als Luft- bzw. Satellitenbild. Dank der Street View Bilder und den hochwertigen
            Satellitenbildern sind sehr genaue Darstellungen möglich.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Google Maps auf unserer Webseite?</h3>
          <p>
            All unsere Bemühungen auf dieser Seite verfolgen das Ziel, Ihnen eine nützliche und sinnvolle Zeit auf
            unserer Webseite zu bieten. Durch die Einbindung von Google Maps können wir Ihnen die wichtigsten
            Informationen zu diversen Standorten liefern. Sie sehen auf einen Blick wo wir unseren Firmensitz haben. Die
            Wegbeschreibung zeigt Ihnen immer den besten bzw. schnellsten Weg zu uns. Sie können den Anfahrtsweg für
            Routen mit dem Auto, mit öffentlichen Verkehrsmitteln, zu Fuß oder mit dem Fahrrad abrufen. Für uns ist die
            Bereitstellung von Google Maps Teil unseres Kundenservice.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Google Maps gespeichert?</h3>
          <p>
            Damit Google Maps ihren Dienst vollständig anbieten kann, muss das Unternehmen Daten von Ihnen aufnehmen und
            speichern. Dazu zählen unter anderem die eingegebenen Suchbegriffe, Ihre IP-Adresse und auch die Breiten-
            bzw. Längenkoordinaten. Benutzen Sie die Routenplaner-Funktion wird auch die eingegebene Startadresse
            gespeichert. Diese Datenspeicherung passiert allerdings auf den Webseiten von Google Maps. Wir können Sie
            darüber nur informieren, aber keinen Einfluss nehmen. Da wir Google Maps in unsere Webseite eingebunden
            haben, setzt Google mindestens ein Cookie (Name: NID) in Ihrem Browser. Dieses Cookie speichert Daten über
            Ihr Userverhalten. Google nutzt diese Daten in erster Linie, um eigene Dienste zu optimieren und
            individuelle, personalisierte Werbung für Sie bereitzustellen.
          </p>
          <p>Folgendes Cookie wird aufgrund der Einbindung von Google Maps in Ihrem Browser gesetzt:</p>
          <p>Name: NID</p>
          <p>Wert: 188=h26c1Ktha7fCQTx8rXgLyATyITJ221128197-5</p>
          <p>
            Verwendungszweck: NID wird von Google verwendet, um Werbeanzeigen an Ihre Google-Suche anzupassen. Mit Hilfe
            des Cookies „erinnert“ sich Google an Ihre am häufigsten eingegebenen Suchanfragen oder Ihre frühere
            Interaktion mit Anzeigen. So bekommen Sie immer maßgeschneiderte Werbeanzeigen. Das Cookie enthält eine
            einzigartige ID, die Google benutzt, um Ihre persönlichen Einstellungen für Werbezwecke zu sammeln.
          </p>
          <p>Ablaufdatum: nach 6 Monaten</p>
          <p>
            Anmerkung: Wir können bei den Angaben der gespeicherten Daten keine Vollständigkeit gewährleisten. Speziell
            bei der Verwendung von Cookies sind Veränderungen nie auszuschließen. Um das Cookie NID zu identifizieren,
            wurde eine eigene Testseite angelegt, wo ausschließlich Google Maps eingebunden war.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Die Google-Server stehen in Rechenzentren auf der ganzen Welt. Die meisten Server befinden sich allerdings
            in Amerika. Aus diesem Grund werden Ihre Daten auch vermehrt in den USA gespeichert. Hier können Sie genau
            nachlesen wo sich die Google-Rechenzentren befinden:
            <a
              href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.google.com/about/datacenters/inside/locations/?hl=de</a
            >
          </p>
          <p>
            Die Daten verteilt Google auf verschiedenen Datenträgern. Dadurch sind die Daten schneller abrufbar und
            werden vor etwaigen Manipulationsversuchen besser geschützt. Jedes Rechenzentrum hat auch spezielle
            Notfallprogramme. Wenn es zum Beispiel Probleme bei der Google-Hardware gibt oder eine Naturkatastrophe die
            Server lahm legt, bleiben die Daten ziemlich sicher trotzdem geschützt.
          </p>
          <p>
            Manche Daten speichert Google für einen festgelegten Zeitraum. Bei anderen Daten bietet Google lediglich die
            Möglichkeit, diese manuell zu löschen. Weiters anonymisiert das Unternehmen auch Informationen (wie zum
            Beispiel Werbedaten) in Serverprotokollen, indem es einen Teil der IP-Adresse und Cookie-Informationen nach
            9 bzw.18 Monaten löscht.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Mit der 2019 eingeführten automatischen Löschfunktion von Standort- und Aktivitätsdaten werden Informationen
            zur Standortbestimmung und Web-/App-Aktivität – abhängig von Ihrer Entscheidung – entweder 3 oder 18 Monate
            gespeichert und dann gelöscht. Zudem kann man diese Daten über das Google-Konto auch jederzeit manuell aus
            dem Verlauf löschen. Wenn Sie Ihre Standorterfassung vollständig verhindern wollen, müssen Sie im
            Google-Konto die Rubrik „Web- und App-Aktivität“ pausieren. Klicken Sie „Daten und Personalisierung“ und
            dann auf die Option „Aktivitätseinstellung“. Hier können Sie die Aktivitäten ein- oder ausschalten.
          </p>
          <p>
            In Ihrem Browser können Sie weiters auch einzelne Cookies deaktivieren, löschen oder verwalten. Je nach dem
            welchen Browser Sie verwenden, funktioniert dies immer etwas anders. Die folgenden Anleitungen zeigen, wie
            Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie es erlauben oder nicht.
          </p>
          <p>
            Google ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework, wodurch der korrekte und sichere
            Datentransfer persönlicher Daten geregelt wird. Mehr Informationen dazu finden Sie auf
            <a
              href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI</a
            >. Wenn Sie mehr über die Datenverarbeitung von Google erfahren wollen, empfehlen wir Ihnen die hauseigene
            Datenschutzerklärung des Unternehmens unter
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer"
              >https://policies.google.com/privacy?hl=de</a
            >.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Google Fonts Datenschutzerklärung</h2>
          <p>
            Auf unserer Website verwenden wir Google Fonts. Das sind die „Google-Schriften“ der Firma Google Inc. Für
            den europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
            Irland) für alle Google-Dienste verantwortlich.
          </p>
          <p>
            Für die Verwendung von Google-Schriftarten müssen Sie sich nicht anmelden bzw. ein Passwort hinterlegen.
            Weiters werden auch keine Cookies in Ihrem Browser gespeichert. Die Dateien (CSS, Schriftarten/Fonts) werden
            über die Google-Domains <a href="http://fonts.googleapis.com/">fonts.googleapis.com</a> und
            <a href="http://fonts.gstatic.com/">fonts.gstatic.com</a> angefordert. Laut Google sind die Anfragen nach
            CSS und Schriften vollkommen getrennt von allen anderen Google-Diensten. Wenn Sie ein Google-Konto haben,
            brauchen Sie keine Sorge haben, dass Ihre Google-Kontodaten, während der Verwendung von Google Fonts, an
            Google übermittelt werden. Google erfasst die Nutzung von CSS (Cascading Style Sheets) und der verwendeten
            Schriftarten und speichert diese Daten sicher. Wie die Datenspeicherung genau aussieht, werden wir uns noch
            im Detail ansehen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was sind Google Fonts?</h3>
          <p>
            Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit über 800 Schriftarten, die
            <a href="https://de.wikipedia.org/wiki/Google_LLC?tid=221128197">Google</a>
            Ihren Nutzern kostenlos zu Verfügung stellen.
          </p>
          <p>
            Viele dieser Schriftarten sind unter der SIL Open Font License veröffentlicht, während andere unter der
            Apache-Lizenz veröffentlicht wurden. Beides sind freie Software-Lizenzen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Google Fonts auf unserer Webseite?</h3>
          <p>
            Mit Google Fonts können wir auf der eigenen Webseite Schriften nutzen, und müssen sie nicht auf unserem
            eigenen Server hochladen. Google Fonts ist ein wichtiger Baustein, um die Qualität unserer Webseite hoch zu
            halten. Alle Google-Schriften sind automatisch für das Web optimiert und dies spart Datenvolumen und ist
            speziell für die Verwendung bei mobilen Endgeräten ein großer Vorteil. Wenn Sie unsere Seite besuchen, sorgt
            die niedrige Dateigröße für eine schnelle Ladezeit. Des Weiteren sind Google Fonts sichere Web Fonts.
            Unterschiedliche Bildsynthese-Systeme (Rendering) in verschiedenen Browsern, Betriebssystemen und mobilen
            Endgeräten können zu Fehlern führen. Solche Fehler können teilweise Texte bzw. ganze Webseiten optisch
            verzerren. Dank des schnellen Content Delivery Network (CDN) gibt es mit Google Fonts keine
            plattformübergreifenden Probleme. Google Fonts unterstützt alle gängigen Browser (Google Chrome, Mozilla
            Firefox, Apple Safari, Opera) und funktioniert zuverlässig auf den meisten modernen mobilen
            Betriebssystemen, einschließlich Android 2.2+ und iOS 4.2+ (iPhone, iPad, iPod). Wir verwenden die Google
            Fonts also, damit wir unser gesamtes Online-Service so schön und einheitlich wie möglich darstellen können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Google gespeichert?</h3>
          <p>
            Wenn Sie unsere Webseite besuchen, werden die Schriften über einen Google-Server nachgeladen. Durch diesen
            externen Aufruf werden Daten an die Google-Server übermittelt. So erkennt Google auch, dass Sie bzw. Ihre
            IP-Adresse unsere Webseite besucht. Die Google Fonts API wurde entwickelt, um Verwendung, Speicherung und
            Erfassung von Endnutzerdaten auf das zu reduzieren, was für eine ordentliche Bereitstellung von Schriften
            nötig ist. API steht übrigens für „Application Programming Interface“ und dient unter anderem als
            Datenübermittler im Softwarebereich.
          </p>
          <p>
            Google Fonts speichert CSS- und Schrift-Anfragen sicher bei Google und ist somit geschützt. Durch die
            gesammelten Nutzungszahlen kann Google feststellen, wie gut die einzelnen Schriften ankommen. Die Ergebnisse
            veröffentlicht Google auf internen Analyseseiten, wie beispielsweise Google Analytics. Zudem verwendet
            Google auch Daten des eigenen Web-Crawlers, um festzustellen, welche Webseiten Google-Schriften verwenden.
            Diese Daten werden in der BigQuery-Datenbank von Google Fonts veröffentlicht. Unternehmer und Entwickler
            nützen das Google-Webservice BigQuery, um große Datenmengen untersuchen und bewegen zu können.
          </p>
          <p>
            Zu bedenken gilt allerdings noch, dass durch jede Google Font Anfrage auch Informationen wie
            Spracheinstellungen, IP-Adresse, Version des Browsers, Bildschirmauflösung des Browsers und Name des
            Browsers automatisch an die Google-Server übertragen werden. Ob diese Daten auch gespeichert werden, ist
            nicht klar feststellbar bzw. wird von Google nicht eindeutig kommuniziert.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Anfragen für CSS-Assets speichert Google einen Tag lang auf seinen Servern, die hauptsächlich außerhalb der
            EU angesiedelt sind. Das ermöglicht uns, mithilfe eines Google-Stylesheets die Schriftarten zu nutzen. Ein
            Stylesheet ist eine Formatvorlage, über die man einfach und schnell z.B. das Design bzw. die Schriftart
            einer Webseite ändern kann.
          </p>
          <p>
            Die Font-Dateien werden bei Google ein Jahr gespeichert. Google verfolgt damit das Ziel, die Ladezeit von
            Webseiten grundsätzlich zu verbessern. Wenn Millionen von Webseiten auf die gleichen Schriften verweisen,
            werden sie nach dem ersten Besuch zwischengespeichert und erscheinen sofort auf allen anderen später
            besuchten Webseiten wieder. Manchmal aktualisiert Google Schriftdateien, um die Dateigröße zu reduzieren,
            die Abdeckung von Sprache zu erhöhen und das Design zu verbessern.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Jene Daten, die Google für einen Tag bzw. ein Jahr speichert können nicht einfach gelöscht werden. Die Daten
            werden beim Seitenaufruf automatisch an Google übermittelt. Um diese Daten vorzeitig löschen zu können,
            müssen Sie den Google-Support auf
            <a href="https://support.google.com/?hl=de&tid=221128197" target="_blank" rel="noopener noreferrer"
              >https://support.google.com/?hl=de&tid=221128197</a
            >
            kontaktieren. Datenspeicherung verhindern Sie in diesem Fall nur, wenn Sie unsere Seite nicht besuchen.
          </p>
          <p>
            Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff auf alle Schriftarten. Wir
            können also unlimitiert auf ein Meer an Schriftarten zugreifen und so das Optimum für unsere Webseite
            rausholen. Mehr zu Google Fonts und weiteren Fragen finden Sie auf
            <a href="https://developers.google.com/fonts/faq?tid=221128197" target="_blank" rel="noopener noreferrer"
              >https://developers.google.com/fonts/faq?tid=221128197</a
            >. Dort geht zwar Google auf datenschutzrelevante Angelegenheiten ein, doch wirklich detaillierte
            Informationen über Datenspeicherung sind nicht enthalten. Es ist relativ schwierig, von Google wirklich
            präzise Informationen über gespeicherten Daten zu bekommen.
          </p>
          <p>
            Welche Daten grundsätzlich von Google erfasst werden und wofür diese Daten verwendet werden, können Sie auch
            auf
            <a href="https://www.google.com/intl/de/policies/privacy/" target="_blank" rel="noopener noreferrer"
              >https://www.google.com/intl/de/policies/privacy/</a
            >
            nachlesen.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Google Fonts Lokal Datenschutzerklärung</h2>
          <p>
            Auf unserer Website nutzen wir Google Fonts der Firma Google Inc. Für den europäischen Raum ist das
            Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Wir haben
            die Google-Schriftarten lokal, d.h. auf unserem Webserver – nicht auf den Servern von Google – eingebunden.
            Dadurch gibt es keine Verbindung zu Google-Servern und somit auch keine Datenübertragung oder Speicherung.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was sind Google Fonts?</h3>
          <p>
            Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt es sich um ein interaktives Verzeichnis
            mit über 800 Schriftarten, die Google kostenlos bereitstellt. Mit Google Fonts könnte man Schriften nutzen,
            ohne sie auf den eigenen Server hochzuladen. Doch um diesbezüglich jede Informationsübertragung zu
            Google-Servern zu unterbinden, haben wir die Schriftarten auf unseren Server heruntergeladen. Auf diese
            Weise handeln wir datenschutzkonform und senden keine Daten an Google Fonts weiter.
          </p>
          <p>
            Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff auf alle Schriftarten. Wir
            können also unlimitiert auf ein Meer an Schriftarten zugreifen und so das Optimum für unsere Webseite
            rausholen. Mehr zu Google Fonts und weiteren Fragen finden Sie auf
            <a href="https://developers.google.com/fonts/faq?tid=221128197" target="_blank" rel="noopener noreferrer"
              >https://developers.google.com/fonts/faq?tid=221128197</a
            >.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Google Analytics Datenschutzerklärung</h2>
          <p>
            Wir verwenden auf unserer Website das Analyse-Tracking Tool Google Analytics (GA) des amerikanischen
            Unternehmens Google Inc. Für den europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House,
            Barrow Street Dublin 4, Irland) für alle Google-Dienste verantwortlich. Google Analytics sammelt Daten über
            Ihre Handlungen auf unserer Website. Wenn Sie beispielsweise einen Link anklicken, wird diese Aktion in
            einem Cookie gespeichert und an Google Analytics versandt. Mithilfe der Berichte, die wir von Google
            Analytics erhalten, können wir unsere Website und unser Service besser an Ihre Wünsche anpassen. Im
            Folgenden gehen wir näher auf das Tracking Tool ein und informieren Sie vor allem darüber, welche Daten
            gespeichert werden und wie Sie das verhindern können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist Google Analytics?</h3>
          <p>
            Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse unserer Website dient. Damit Google
            Analytics funktioniert, wird ein Tracking-Code in den Code unserer Website eingebaut. Wenn Sie unsere
            Website besuchen, zeichnet dieser Code verschiedene Handlungen auf, die Sie auf unserer Website ausführen.
            Sobald Sie unsere Website verlassen, werden diese Daten an die Google-Analytics-Server gesendet und dort
            gespeichert.
          </p>
          <p>
            Google verarbeitet die Daten und wir bekommen Berichte über Ihr Userverhalten. Dabei kann es sich unter
            anderem um folgende Berichte handeln:
          </p>
          <p>
            Zielgruppenberichte: Über Zielgruppenberichte lernen wir unsere User besser kennen und wissen genauer, wer
            sich für unser Service interessiert.
          </p>
          <p>
            Anzeigeberichte: Durch Anzeigeberichte können wir unsere Onlinewerbung leichter analysieren und verbessern.
          </p>
          <p>
            Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche Informationen darüber, wie wir mehr Menschen
            für unser Service begeistern können.
          </p>
          <p>
            Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website interagieren. Wir können nachvollziehen
            welchen Weg Sie auf unserer Seite zurücklegen und welche Links Sie anklicken.
          </p>
          <p>
            Conversionsberichte: Conversion nennt man einen Vorgang, bei dem Sie aufgrund einer Marketing-Botschaft eine
            gewünschte Handlung ausführen. Zum Beispiel, wenn Sie von einem reinen Websitebesucher zu einem Käufer oder
            Newsletter-Abonnent werden. Mithilfe dieser Berichte erfahren wir mehr darüber, wie unsere
            Marketing-Maßnahmen bei Ihnen ankommen. So wollen wir unsere Conversionrate steigern.
          </p>
          <p>
            Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf unserer Website passiert. Zum Beispiel
            sehen wir wie viele User gerade diesen Text lesen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Google Analytics auf unserer Webseite?</h3>
          <p>
            Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen das bestmögliche Service bieten. Die Statistiken
            und Daten von Google Analytics helfen uns dieses Ziel zu erreichen.
          </p>
          <p>
            Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von den Stärken und Schwächen unserer
            Website. Einerseits können wir unsere Seite so optimieren, dass sie von interessierten Menschen auf Google
            leichter gefunden wird. Andererseits helfen uns die Daten, Sie als Besucher besser zu verstehen. Wir wissen
            somit sehr genau, was wir an unserer Website verbessern müssen, um Ihnen das bestmögliche Service zu bieten.
            Die Daten dienen uns auch, unsere Werbe- und Marketing-Maßnahmen individueller und kostengünstiger
            durchzuführen. Schließlich macht es nur Sinn, unsere Produkte und Dienstleistungen Menschen zu zeigen, die
            sich dafür interessieren.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Google Analytics gespeichert?</h3>
          <p>
            Google Analytics erstellt mithilfe eines Tracking-Codes eine zufällige, eindeutige ID, die mit Ihrem
            Browser-Cookie verbunden ist. So erkennt Sie Google Analytics als neuen User. Wenn Sie das nächste Mal
            unsere Seite besuchen, werden Sie als „wiederkehrender“ User erkannt. Alle gesammelten Daten werden
            gemeinsam mit dieser User-ID gespeichert. So ist es überhaupt erst möglich pseudonyme Userprofile
            auszuwerten.
          </p>
          <p>
            Durch Kennzeichnungen wie Cookies und App-Instanz-IDs werden Ihre Interaktionen auf unserer Website
            gemessen. Interaktionen sind alle Arten von Handlungen, die Sie auf unserer Website ausführen. Wenn Sie auch
            andere Google-Systeme (wie z.B. ein Google-Konto) nützen, können über Google Analytics generierte Daten mit
            Drittanbieter-Cookies verknüpft werden. Google gibt keine Google Analytics-Daten weiter, außer wir als
            Websitebetreiber genehmigen das. Zu Ausnahmen kann es kommen, wenn es gesetzlich erforderlich ist.
          </p>
          <p>Folgende Cookies werden von Google Analytics verwendet:</p>
          <p>Name: _ga</p>
          <p>Wert:2.1326744211.152221128197-5</p>
          <p>
            Verwendungszweck: Standardmäßig verwendet analytics.js das Cookie _ga, um die User-ID zu speichern.
            Grundsätzlich dient es zur Unterscheidung der Webseitenbesucher.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: _gid</p>
          <p>Wert:2.1687193234.152221128197-1</p>
          <p>Verwendungszweck: Das Cookie dient auch zur Unterscheidung der Webseitenbesucher</p>
          <p>Ablaufdatum: nach 24 Stunden</p>
          <p>Name: _gat_gtag_UA_Wert: 1</p>
          <p>
            Verwendungszweck: Wird zum Senken der Anforderungsrate verwendet. Wenn Google Analytics über den Google Tag
            Manager bereitgestellt wird, erhält dieser Cookie den Namen _dc_gtm_ .
          </p>
          <p>Ablaufdatum: nach 1 Minute</p>
          <p>Name: AMP_TOKEN</p>
          <p>Wert: keine Angaben</p>
          <p>
            Verwendungszweck: Das Cookie hat einen Token, mit dem eine User ID vom AMP-Client-ID-Dienst abgerufen werden
            kann. Andere mögliche Werte weisen auf eine Abmeldung, eine Anfrage oder einen Fehler hin.
          </p>
          <p>Ablaufdatum: nach 30 Sekunden bis zu einem Jahr</p>
          <p>Name: __utma</p>
          <p>Wert:1564498958.1564498958.1564498958.1</p>
          <p>
            Verwendungszweck: Mit diesem Cookie kann man Ihr Verhalten auf der Website verfolgen und die Leistung
            messen. Das Cookie wird jedes Mal aktualisiert, wenn Informationen an Google Analytics gesendet werden.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: __utmt</p>
          <p>Wert: 1</p>
          <p>Verwendungszweck: Das Cookie wird wie _gat_gtag_UA_ zum Drosseln der Anforderungsrate verwendet.</p>
          <p>Ablaufdatum: nach 10 Minuten</p>
          <p>Name: __utmb</p>
          <p>Wert:3.10.1564498958</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, um neue Sitzungen zu bestimmen. Es wird jedes Mal
            aktualisiert, wenn neue Daten bzw. Infos an Google Analytics gesendet werden.
          </p>
          <p>Ablaufdatum: nach 30 Minuten</p>
          <p>Name: __utmc</p>
          <p>Wert: 167421564</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, um neue Sitzungen für wiederkehrende Besucher festzulegen.
            Dabei handelt es sich um ein Session-Cookie und wird nur solange gespeichert, bis Sie den Browser wieder
            schließen.
          </p>
          <p>Ablaufdatum: Nach Schließung des Browsers</p>
          <p>Name: __utmz</p>
          <p>Wert: m|utmccn=(referral)|utmcmd=referral|utmcct=/</p>
          <p>
            Verwendungszweck: Das Cookie wird verwendet, um die Quelle des Besucheraufkommens auf unserer Website zu
            identifizieren. Das heißt, das Cookie speichert, von wo Sie auf unsere Website gekommen sind. Das kann eine
            andere Seite bzw. eine Werbeschaltung gewesen sein.
          </p>
          <p>Ablaufdatum: nach 6 Monaten</p>
          <p>Name: __utmv</p>
          <p>Wert: keine Angabe</p>
          <p>
            Verwendungszweck: Das Cookie wird verwendet, um benutzerdefinierte Userdaten zu speichern. Es wird immer
            aktualisiert, wenn Informationen an Google Analytics gesendet werden.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>
            Anmerkung: Diese Aufzählung kann keinen Anspruch auf Vollständigkeit erheben, da Google die Wahl ihrer
            Cookies immer wieder auch verändert.
          </p>
          <p>
            Hier zeigen wir Ihnen einen Überblick über die wichtigsten Daten, die mit Google Analytics erhoben werden:
          </p>
          <p>
            Heatmaps: Google legt sogenannte Heatmaps an. Über Heatmaps sieht man genau jene Bereiche, die Sie
            anklicken. So bekommen wir Informationen, wo Sie auf unserer Seite „unterwegs“ sind.
          </p>
          <p>
            Sitzungsdauer: Als Sitzungsdauer bezeichnet Google die Zeit, die Sie auf unserer Seite verbringen, ohne die
            Seite zu verlassen. Wenn Sie 20 Minuten inaktiv waren, endet die Sitzung automatisch.
          </p>
          <p>
            Absprungrate (engl. Bouncerate): Von einem Absprung ist die Rede, wenn Sie auf unserer Website nur eine
            Seite ansehen und dann unsere Website wieder verlassen.
          </p>
          <p>
            Kontoerstellung: Wenn Sie auf unserer Website ein Konto erstellen bzw. eine Bestellung machen, erhebt Google
            Analytics diese Daten.
          </p>
          <p>
            IP-Adresse: Die IP-Adresse wird nur in gekürzter Form dargestellt, damit keine eindeutige Zuordnung möglich
            ist.
          </p>
          <p>
            Standort: Über die IP-Adresse kann das Land und Ihr ungefährer Standort bestimmt werden. Diesen Vorgang
            bezeichnet man auch als IP- Standortbestimmung.
          </p>
          <p>
            Technische Informationen: Zu den technischen Informationen zählen unter anderem Ihr Browsertyp, Ihr
            Internetanbieter oder Ihre Bildschirmauflösung.
          </p>
          <p>
            Herkunftsquelle: Google Analytics beziehungsweise uns interessiert natürlich auch über welche Website oder
            welche Werbung Sie auf unsere Seite gekommen sind.
          </p>
          <p>
            Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen von Medien (z.B., wenn Sie ein Video
            über unsere Seite abspielen), das Teilen von Inhalten über Social Media oder das Hinzufügen zu Ihren
            Favoriten. Die Aufzählung hat keinen Vollständigkeitsanspruch und dient nur zu einer allgemeinen
            Orientierung der Datenspeicherung durch Google Analytics.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Google hat Ihre Server auf der ganzen Welt verteilt. Die meisten Server befinden sich in Amerika und
            folglich werden Ihr Daten meist auf amerikanischen Servern gespeichert. Hier können Sie genau nachlesen wo
            sich die Google-Rechenzentren befinden:
            <a
              href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.google.com/about/datacenters/inside/locations/?hl=de</a
            >
          </p>
          <p>
            Ihre Daten werden auf verschiedenen physischen Datenträgern verteilt. Das hat den Vorteil, dass die Daten
            schneller abrufbar sind und vor Manipulation besser geschützt sind. In jedem Google-Rechenzentrum gibt es
            entsprechende Notfallprogramme für Ihre Daten. Wenn beispielsweise die Hardware bei Google ausfällt oder
            Naturkatastrophen Server lahmlegen, bleibt das Risiko einer Dienstunterbrechung bei Google dennoch gering.
          </p>
          <p>
            Standardisiert ist bei Google Analytics eine Aufbewahrungsdauer Ihrer Userdaten von 26 Monaten eingestellt.
            Dann werden Ihre Userdaten gelöscht. Allerdings haben wir die Möglichkeit, die Aufbewahrungsdauer von
            Nutzdaten selbst zu wählen. Dafür stehen uns fünf Varianten zur Verfügung:
          </p>
          <p>Löschung nach 14 Monaten</p>
          <p>Löschung nach 26 Monaten</p>
          <p>Löschung nach 38 Monaten</p>
          <p>Löschung nach 50 Monaten</p>
          <p>Keine automatische Löschung</p>
          <p>
            Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat die Daten gelöscht. Diese
            Aufbewahrungsdauer gilt für Ihre Daten, die mit Cookies, Usererkennung und Werbe-IDs (z.B. Cookies der
            DoubleClick-Domain) verknüpft sind. Berichtergebnisse basieren auf aggregierten Daten und werden unabhängig
            von Nutzerdaten gespeichert. Aggregierte Daten sind eine Zusammenschmelzung von Einzeldaten zu einer
            größeren Einheit.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Nach dem Datenschutzrecht der Europäischen Union haben Sie das Recht, Auskunft über Ihre Daten zu erhalten,
            sie zu aktualisieren, zu löschen oder einzuschränken. Mithilfe des Browser-Add-ons zur Deaktivierung von
            Google Analytics-JavaScript (ga.js, analytics.js, dc.js) verhindern Sie, dass Google Analytics Ihre Daten
            verwendet. Das Browser-Add-on können Sie unter
            <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer"
              >https://tools.google.com/dlpage/gaoptout?hl=de</a
            >
            runterladen und installieren. Beachten Sie bitte, dass durch dieses Add-on nur die Datenerhebung durch
            Google Analytics deaktiviert wird.
          </p>
          <p>
            Falls Sie grundsätzlich Cookies (unabhängig von Google Analytics) deaktivieren, löschen oder verwalten
            wollen, gibt es für jeden Browser eine eigene Anleitung:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Google Analytics ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework, wodurch der korrekte und
            sichere Datentransfer persönlicher Daten geregelt wird. Mehr Informationen dazu finden Sie auf
            <a
              href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=221128197"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=221128197</a
            >. Wir hoffen wir konnten Ihnen die wichtigsten Informationen rund um die Datenverarbeitung von Google
            Analytics näherbringen. Wenn Sie mehr über den Tracking-Dienst erfahren wollen, empfehlen wir diese beiden
            Links:
            <a href="http://www.google.com/analytics/terms/de.html" target="_blank" rel="noopener noreferrer"
              >http://www.google.com/analytics/terms/de.html</a
            >
            und
            <a
              href="https://support.google.com/analytics/answer/6004245?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              >https://support.google.com/analytics/answer/6004245?hl=de</a
            >.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Google Analytics IP-Anonymisierung</h3>
          <p>
            Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google Analytics implementiert. Diese
            Funktion wurde von Google entwickelt, damit diese Webseite die geltenden Datenschutzbestimmungen und
            Empfehlungen der lokalen Datenschutzbehörden einhalten kann, wenn diese eine Speicherung der vollständigen
            IP-Adresse untersagen. Die Anonymisierung bzw. Maskierung der IP findet statt, sobald die IP-Adressen im
            Google Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung oder Verarbeitung der Daten
            stattfindet.
          </p>
          <p>
            Mehr Informationen zur IP-Anonymisierung finden Sie auf
            <a
              href="https://support.google.com/analytics/answer/2763052?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              >https://support.google.com/analytics/answer/2763052?hl=de</a
            >.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Google Analytics Berichte zu demografischen Merkmalen und Interessen
          </h3>
          <p>
            Wir haben in Google Analytics die Funktionen für Werbeberichte eingeschaltet. Die Berichte zu demografischen
            Merkmalen und Interessen enthalten Angaben zu Alter, Geschlecht und Interessen. Damit können wir uns – ohne
            diese Daten einzelnen Personen zuordnen zu können – ein besseres Bild von unseren Nutzern machen. Mehr über
            die Werbefunktionen erfahren Sie auf
            <a
              href="https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad"
              target="_blank"
              rel="noopener noreferrer"
              >https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad</a
            >.
          </p>
          <p>
            Sie können die Nutzung der Aktivitäten und Informationen Ihres Google Kontos unter “Einstellungen für
            Werbung” auf
            <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer"
              >https://adssettings.google.com/authenticated</a
            >
            per Checkbox beenden.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Google Analytics Deaktivierungslink</h3>
          <p>
            Wenn Sie auf folgenden Deaktivierungslink klicken, können Sie verhindern, dass Google weitere Besuche auf
            dieser Webseite erfasst. Achtung: Das Löschen von Cookies, die Nutzung des Inkognito/Privatmodus ihres
            Browsers, oder die Nutzung eines anderen Browsers führt dazu, dass wieder Daten erhoben werden.
          </p>
          <p>Google Analytics deaktivieren</p>
          <h3 class="text-base font-semibold mt-6 mb-2">Google Analytics Zusatz zur Datenverarbeitung</h3>
          <p>
            Wir haben mit Google einen Direktkundenvertrag zur Verwendung von Google Analytics abgeschlossen, indem wir
            den “Zusatz zur Datenverarbeitung” in Google Analytics akzeptiert haben.
          </p>
          <p>
            Mehr über den Zusatz zur Datenverarbeitung für Google Analytics finden Sie hier:
            <a
              href="https://support.google.com/analytics/answer/3379636?hl=de&utm_id=ad"
              target="_blank"
              rel="noopener noreferrer"
              >https://support.google.com/analytics/answer/3379636?hl=de&utm_id=ad</a
            >
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Google Analytics Google-Signale Datenschutzerklärung</h3>
          <p>
            Wir haben in Google Analytics die Google-Signale aktiviert. So werden die bestehenden
            Google-Analytics-Funktionen (Werbeberichte, Remarketing, gerätübergreifende Berichte und Berichte zu
            Interessen und demografische Merkmale) aktualisiert, um zusammengefasste und anonymisierte Daten von Ihnen
            zu erhalten, sofern Sie personalisierte Anzeigen in Ihrem Google-Konto erlaubt haben.
          </p>
          <p>
            Das besondere daran ist, dass es sich dabei um ein Cross-Device-Tracking handelt. Das heißt Ihre Daten
            können geräteübergreifend analysiert werden. Durch die Aktivierung von Google-Signale werden Daten erfasst
            und mit dem Google-Konto verknüpft. Google kann dadurch zum Beispiel erkennen, wenn Sie auf unsere Webseite
            über ein Smartphone ein Produkt ansehen und erst später über einen Laptop das Produkt kaufen. Dank der
            Aktivierung von Google-Signale können wir gerätübergreifende Remarketing-Kampagnen starten, die sonst in
            dieser Form nicht möglich wären. Remarketing bedeutet, dass wir Ihnen auch auf anderen Webseiten unser
            Angebot zeigen können.
          </p>
          <p>
            In Google Analytics werden zudem durch die Google-Signale weitere Besucherdaten wie Standort, Suchverlauf,
            YouTube-Verlauf und Daten über Ihre Handlungen auf unserer Webseite, erfasst. Wir erhalten dadurch von
            Google bessere Werbeberichte und nützlichere Angaben zu Ihren Interessen und demografischen Merkmalen. Dazu
            gehören Ihr Alter, welche Sprache sie sprechen, wo Sie wohnen oder welchem Geschlecht Sie angehören. Weiters
            kommen auch noch soziale Kriterien wie Ihr Beruf, Ihr Familienstand oder Ihr Einkommen hinzu. All diese
            Merkmal helfen Google Analytics Personengruppen bzw. Zielgruppen zu definieren.
          </p>
          <p>
            Die Berichte helfen uns auch Ihr Verhalten, Ihre Wünsche und Interessen besser einschätzen zu können.
            Dadurch können wir unsere Dienstleistungen und Produkte für Sie optimieren und anpassen. Diese Daten laufen
            standardmäßig nach 26 Monaten ab. Bitte beachten Sie, dass diese Datenerfassung nur erfolgt, wenn Sie
            personalisierte Werbung in Ihrem Google-Konto zugelassen haben. Es handelt sich dabei immer um
            zusammengefasste und anonyme Daten und nie um Daten einzelner Personen. In Ihrem Google-Konto können Sie
            diese Daten verwalten bzw. auch löschen.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Newsletter Datenschutzerklärung</h2>
          <p>
            Wenn Sie sich für unseren Newsletter eintragen übermitteln Sie die oben genannten persönlichen Daten und
            geben uns das Recht Sie per E-Mail zu kontaktieren. Die im Rahmen der Anmeldung zum Newsletter gespeicherten
            Daten nutzen wir ausschließlich für unseren Newsletter und geben diese nicht weiter.
          </p>
          <p>
            Sollten Sie sich vom Newsletter abmelden – Sie finden den Link dafür in jedem Newsletter ganz unten – dann
            löschen wir alle Daten die mit der Anmeldung zum Newsletter gespeichert wurden.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Google AdSense Datenschutzerklärung</h2>
          <p>
            Wir verwenden auf dieser Webseite Google AdSense. Das ist ein Anzeigenprogramm der Firma Google Inc. (1600
            Amphitheatre Parkway Mountain View, CA 94043, USA). Mit Google AdSense können wir auf dieser Webseite
            Werbeanzeigen einblenden, die zu unserem Thema passen. So bieten wir Ihnen Anzeigen, die im Idealfall einen
            richtigen Mehrwert für Sie darstellen. Im Zuge dieser Datenschutzerklärung über Google AdSense erklären wir
            Ihnen, warum wir Google AdSense auf unserer Webseite verwenden, welche Daten von Ihnen verarbeitet und
            gespeichert werden und wie Sie diese Datenspeicherung unterbinden können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist Google AdSense?</h3>
          <p>
            Das Werbeprogramm Google AdSense gibt es mittlerweile seit 2003. Im Gegensatz zu Google Ads (früher: Google
            AdWords) kann man hier nicht selbst Werbung schalten. Über Google AdSense werden Werbeanzeigen auf
            Webseiten, wie zum Beispiel auf unserer, ausgespielt. Der größte Vorteil dieses Werbedienstes im Vergleich
            zu manch anderen ist, dass Ihnen Google AdSense nur Anzeigen zeigt, die zu unseren Inhalten passen. Google
            hat einen eigenen Algorithmus, der berechnet, welche Werbeanzeigen Sie zu Gesicht bekommen. Natürlich wollen
            wir Ihnen nur Werbung bieten, die Sie auch interessiert und Ihnen einen Mehrwert bietet. Google überprüft
            anhand Ihrer Interessen bzw. Ihres Userverhaltens und anhand unseres Angebots, welche Werbeanzeigen für
            unsere Webseite und für unserer User geeignet sind. An dieser Stelle wollen wir auch gleich erwähnen, dass
            wir für die Auswahl der Werbeanzeigen nicht verantwortlich sind. Wir bieten mit unserer Webseite lediglich
            die Werbefläche an. Die Auswahl der angezeigten Werbung trifft Google. Seit August 2013 werden die Anzeigen
            auch an die jeweilige Benutzeroberfläche angepasst. Das heißt, egal ob Sie von Ihrem Smartphone, Ihrem PC
            oder Laptop unsere Webseite besuchen, die Anzeigen passen sich an Ihr Endgerät an.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Google AdSense auf unserer Webseite?</h3>
          <p>
            Das Betreiben einer hochwertigen Webseite erfordert viel Hingabe und großen Einsatz. Im Grunde sind wir mit
            der Arbeit an unserer Webseite nie fertig. Wir versuchen stets unsere Seite zu pflegen und so aktuell wie
            möglich zu halten. Natürlich wollen wir mit dieser Arbeit auch einen wirtschaftlichen Erfolg erzielen. Darum
            haben wir uns für Werbeanzeigen als Einnahmequelle entschieden. Das Wichtigste für uns ist allerdings, Ihren
            Besuch auf unserer Webseite durch diese Anzeigen nicht zu stören. Mithilfe von Google AdSense wird Ihnen nur
            Werbung angeboten, die zu unseren Themen und Ihren Interessen passt.
          </p>
          <p>
            Ähnlich wie bei der Google-Indexierung für eine Webseite, untersucht ein Bot den entsprechenden Content und
            die entsprechenden Angebote unserer Webseite. Dann werden die Werbeanzeigen inhaltlich angepasst und auf der
            Webseite präsentiert. Neben den inhaltlichen Überschneidungen zwischen Anzeige und Webseiten-Angebot
            unterstützt AdSense auch interessensbezogenes Targeting. Das bedeutet, dass Google auch Ihre Daten dazu
            verwendet, um auf Sie zugeschnittene Werbung anzubieten. So erhalten Sie Werbung, die Ihnen im Idealfall
            einen echten Mehrwert bietet und wir haben eine höhere Chance ein bisschen etwas zu verdienen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Google AdSense gespeichert?</h3>
          <p>
            Damit Google AdSense eine maßgeschneiderte, auf Sie angepasste Werbung anzeigen kann, werden unter anderem
            Cookies verwendet. Cookies sind kleine Textdateien, die bestimmte Informationen auf Ihrem Computer
            speichern.
          </p>
          <p>
            In AdSense sollen Cookies bessere Werbung ermöglichen. Die Cookies enthalten keine personenidentifizierbaren
            Daten. Hierbei ist allerdings zu beachten, dass Google Daten wie zum Beispiel „Pseudonyme Cookie-IDs“ (Name
            oder anderes Identifikationsmerkmal wird durch ein Pseudonym ersetzt) oder IP-Adressen als nicht
            personenidentifizierbare Informationen ansieht. Im Rahmen der DSGVO können diese Daten allerdings als
            personenbezogene Daten gelten. Google AdSense sendet nach jeder Impression (das ist immer dann der Fall,
            wenn Sie eine Anzeige sehen), jedem Klick und jeder anderen Aktivität, die zu einem Aufruf der Google
            AdSense-Server führt, ein Cookie an den Browser. Sofern der Browser das Cookie akzeptiert, wird es dort
            gespeichert.
          </p>
          <p>
            Drittanbieter können im Rahmen von AdSense unter Umständen Cookies in Ihrem Browser platzieren und auslesen
            bzw. Web-Beacons verwenden, um Daten zu speichern, die sie durch die Anzeigenbereitstellung auf der Webseite
            erhalten. Als Web-Beacons bezeichnet man kleine Grafiken, die eine Logdatei-Analyse und eine Aufzeichnung
            der Logdatei machen. Diese Analyse ermöglicht eine statistische Auswertung für das Online-Marketing.
          </p>
          <p>
            Google kann über diese Cookies bestimmte Informationen über Ihr Userverhalten auf unserer Webseite sammeln.
            Dazu zählen:
          </p>
          <p>Informationen wie Sie mit einer Anzeige umgehen (Klicks, Impression, Mausbewegungen)</p>
          <p>
            Informationen, ob in Ihrem Browser schon eine Anzeige zu einem früheren Zeitpunkt erschienen ist. Diese
            Daten helfen dabei, Ihnen eine Anzeige nicht öfter anzuzeigen.
          </p>
          <p>
            Dabei analysiert Google die Daten zu den angezeigten Werbemitteln und Ihre IP-Adresse und wertet diese aus.
            Google verwendet die Daten in erster Linie, um die Effektivität einer Anzeige zu messen und das Werbeangebot
            zu verbessern. Diese Daten werden nicht mit personenbezogenen Daten, die Google möglicherweise über andere
            Google-Dienste von Ihnen hat, verknüpft.
          </p>
          <p>
            Im Folgenden stellen wir Ihnen Cookies vor, die Google AdSense für Trackingzwecke verwendet. Hierbei
            beziehen wir uns auf eine Test-Webseite, die ausschließlich Google AdSense installiert hat:
          </p>
          <p>Name: uid</p>
          <p>Wert: 891269189221128197-0</p>
          <p>
            Verwendungszweck: Das Cookie wird unter der Domain <a href="http://adform.net/">adform.net</a> gespeichert.
            Es stellt eine eindeutig zugewiesene, maschinell generierte User-ID bereit und sammelt Daten über die
            Aktivität auf unserer Webseite.
          </p>
          <p>Ablaufdatum: nach 2 Monaten</p>
          <p>Name: C</p>
          <p>Wert: 1</p>
          <p>
            Verwendungszweck: Dieses Cookie identifiziert, ob Ihrer Browser Cookies akzeptiert. Das Cookie wird unter
            der Domain <a href="http://track.adform.net/">track.adform.net</a> gespeichert.
          </p>
          <p>Ablaufdatum: nach 1 Monat</p>
          <p>Name: cid</p>
          <p>Wert: 8912691894970695056,0,0,0,0</p>
          <p>
            Verwendungszweck: Dieses Cookie wird unter der Domain
            <a href="http://track.adform.net/">track.adform.net</a> gespeichert, steht für Client-ID und wird verwendet,
            um die Werbung für Sie zu verbessern. Es kann relevantere Werbung an den Besucher weiterleiten und hilft,
            die Berichte über die Kampagnenleistung zu verbessern.
          </p>
          <p>Ablaufdatum: nach 2 Monaten</p>
          <p>Name: IDE</p>
          <p>Wert: zOtj4TWxwbFDjaATZ2TzNaQmxrU221128197-3</p>
          <p>
            Verwendungszweck: Das Cookie wird unter der Domain
            <a href="http://doubkeklick.net/">doubkeklick.net</a> gespeichert. Es dient dazu, Ihre Aktionen nach der
            Anzeige bzw. nach dem Klicken der Anzeige zu registrieren. Dadurch kann man messen, wie gut eine Anzeige bei
            unseren Besuchern ankommt.
          </p>
          <p>Ablaufdatum: nach 1 Monat</p>
          <p>Name: test_cookie</p>
          <p>Wert: keine Angabe</p>
          <p>
            Verwendungszweck: Mithilfe des „test_cookies“ kann man überprüfen, ob Ihr Browser überhaupt Cookies
            unterstützt. Das Cookie wird unter der Domain
            <a href="http://doubkeklick.net/">doubkeklick.net</a> gespeichert.
          </p>
          <p>Ablaufdatum: nach 1 Monat</p>
          <p>Name: CT592996</p>
          <p>Wert:733366</p>
          <p>
            Verwendungszweck: Wird unter der Domain <a href="http://adform.net/">adform.net</a> gespeichert. Das Cookie
            wird gesetzt sobald Sie auf eine Werbeanzeige klicken. Genauere Informationen über die Verwendung dieses
            Cookies konnten wir nicht in Erfahrung bringen.
          </p>
          <p>Ablaufdatum: nach einer Stunde</p>
          <p>
            Anmerkung: Diese Aufzählung kann keinen Anspruch auf Vollständigkeit erheben, da Google erfahrungsgemäß die
            Wahl ihrer Cookies immer wieder auch verändert.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Google erfasst Ihre IP-Adresse und verschiedene Aktivitäten, die Sie auf der Webseite ausführen. Cookies
            speichern diese Informationen zu den Interaktionen auf unsere Webseite. Laut Google sammelt und speichert
            das Unternehmen die angegebenen Informationen auf sichere Weise auf den hauseigenen Google-Servern in den
            USA.
          </p>
          <p>
            Wenn Sie kein Google-Konto haben bzw. nicht angemeldet sind, speichert Google die erhobenen Daten mit einer
            eindeutigen Kennung (ID) meist auf Ihrem Browser. Die in Cookies gespeicherten eindeutigen IDs dienen
            beispielsweise dazu, personalisierte Werbung zu gewährleisten. Wenn Sie in einem Google-Konto angemeldet
            sind, kann Google auch personenbezogene Daten erheben.
          </p>
          <p>
            Einige der Daten, die Google speichert, können Sie jederzeit wieder löschen (siehe nächsten Abschnitt).
            Viele Informationen, die in Cookies gespeichert sind, werden automatisch nach einer bestimmten Zeit wieder
            gelöscht. Es gibt allerdings auch Daten, die von Google über einen längeren Zeitraum gespeichert werden.
            Dies ist dann der Fall, wenn Google aus wirtschaftlichen oder rechtlichen Notwendigkeiten, gewisse Daten
            über einen unbestimmten, längeren Zeitraum speichern muss.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Sie haben immer die Möglichkeit Cookies, die sich auf Ihrem Computer befinden, zu löschen oder zu
            deaktivieren. Wie genau das funktioniert hängt von Ihrem Browser ab.
          </p>
          <p>Hier finden Sie die Anleitung, wie Sie Cookies in Ihrem Browser verwalten:</p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie das Cookie erlauben oder nicht. Durch das Herunterladen und Installieren dieses Browser-Plug-ins auf
            <a href="https://support.google.com/ads/answer/7395996" target="_blank" rel="noopener noreferrer"
              >https://support.google.com/ads/answer/7395996</a
            >
            werden ebenfalls alle „Werbecookies“ deaktiviert. Bedenken Sie, dass Sie durch das Deaktivieren dieser
            Cookies nicht die Werbeanzeigen verhindern, sondern nur die personalisierte Werbung.
          </p>
          <p>
            Wenn Sie ein Google Konto besitzen, können Sie auf der Webseite
            <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer"
              >https://adssettings.google.com/authenticated</a
            >
            personalisierte Werbung deaktivieren. Auch hier sehen Sie dann weiter Anzeigen, allerdings sind diese nicht
            mehr an Ihre Interessen angepasst. Dennoch werden die Anzeigen auf der Grundlage von ein paar Faktoren, wie
            Ihrem Standort, dem Browsertyp und der verwendeten Suchbegriffe, angezeigt.
          </p>
          <p>
            Welche Daten Google grundsätzlich erfasst und wofür sie diese Daten verwenden, können Sie auf
            <a href="https://www.google.com/intl/de/policies/privacy/" target="_blank" rel="noopener noreferrer"
              >https://www.google.com/intl/de/policies/privacy/</a
            >
            nachlesen.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">
            Google Ads (Google AdWords) Conversion-Tracking Datenschutzerklärung
          </h2>
          <p>
            Wir verwenden als Online-Marketing-Maßnahme Google Ads (früher Google AdWords), um unsere Produkte und
            Dienstleistungen zu bewerben. So wollen wir im Internet mehr Menschen auf die hohe Qualität unserer Angebote
            aufmerksam machen. Im Rahmen unserer Werbe-Maßnahmen durch Google Ads verwenden wir auf unserer Website das
            Conversion-Tracking der Firma Google Inc. In Europa ist allerdings für alle Google-Dienste das Unternehmen
            Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Mithilfe dieses
            kostenlosen Tracking-Tools können wir unser Werbeangebot an Ihre Interessen und Bedürfnisse besser anpassen.
            Im Folgenden Artikel wollen wir genauer darauf eingehen, warum wir Conversion-Tracking benutzen, welche
            Daten dabei gespeichert werden und wie Sie diese Datenspeicherung verhindern.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist Google Ads Conversion-Tracking?</h3>
          <p>
            Google Ads (früher Google AdWords) ist das hauseigene Online-Werbesystem der Firma Google Inc. Wir sind von
            der Qualität unseres Angebots überzeugt und wollen, dass so viele Menschen wie möglich unsere Webseite
            kennenlernen. Im Onlinebereich bietet Google Ads dafür die beste Plattform. Natürlich wollen wir auch einen
            genauen Überblick über den Kosten-Nutzen-Faktor unserer Werbeaktionen gewinnen. Darum verwenden wir das
            Conversion-Tracking-Tool von Google Ads.
          </p>
          <p>
            Doch was ist eine Conversion eigentlich? Eine Conversion entsteht, wenn Sie von einem rein interessierten
            Webseitenbesucher zu einem handelnden Besucher werden. Dies passiert immer dann, wenn Sie auf unsere Anzeige
            klicken und im Anschluss eine andere Aktion ausführen, wie zum Beispiel unsere Webseite besuchen. Mit dem
            Conversion-Tracking-Tool von Google erfassen wir, was nach einem Klick eines Users auf unsere Google
            Ads-Anzeige geschieht. Zum Beispiel können wir so sehen, ob Produkte gekauft werden, Dienstleistungen in
            Anspruch genommen werden oder ob sich User für unseren Newsletter angemeldet haben.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Warum verwenden wir Google Ads Conversion-Tracking auf unserer Webseite?
          </h3>
          <p>
            Wir setzen Google Ads ein, um auch auf anderen Webseiten auf unser Angebot aufmerksam zu machen. Ziel ist
            es, dass unsere Werbekampagnen wirklich auch nur jene Menschen erreichen, die sich für unsere Angebote
            interessieren. Mit dem Conversion-Tracking Tool sehen wir welche Keywords, Anzeigen, Anzeigengruppen und
            Kampagnen zu den gewünschten Kundenaktionen führen. Wir sehen wie viele Kunden mit unseren Anzeigen auf
            einem Gerät interagieren und dann eine Conversion durchführen. Durch diese Daten können wir unseren
            Kosten-Nutzen-Faktor berechnen, den Erfolg einzelner Werbemaßnahmen messen und folglich unsere
            Online-Marketing-Maßnahmen optimieren. Wir können weiters mithilfe der gewonnenen Daten unsere Webseite für
            Sie interessanter gestalten und unser Werbeangebot noch individueller an Ihre Bedürfnisse anpassen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Welche Daten werden bei Google Ads Conversion-Tracking gespeichert?
          </h3>
          <p>
            Wir haben ein Conversion-Tracking-Tag oder Code-Snippet auf unserer Webseite eingebunden, um gewisse
            User-Aktionen besser analysieren zu können. Wenn Sie nun eine unserer Google Ads-Anzeigen anklicken, wird
            auf Ihrem Computer (meist im Browser) oder Mobilgerät das Cookie „Conversion“ von einer Google-Domain
            gespeichert. Cookies sind kleine Textdateien, die Informationen auf Ihrem Computer speichern.
          </p>
          <p>Hier die Daten der wichtigsten Cookies für das Conversion-Tracking von Google:</p>
          <p>Name: Conversion</p>
          <p>Wert: EhMI_aySuoyv4gIVled3Ch0llweVGAEgt-mr6aXd7dYlSAGQ221128197-3</p>
          <p>
            Verwendungszweck: Dieses Cookie speichert jede Conversion, die Sie auf unserer Seite machen, nachdem Sie
            über eine Google Ad zu uns gekommen sind.
          </p>
          <p>Ablaufdatum: nach 3 Monaten</p>
          <p>Name: _gac</p>
          <p>Wert: 1.1558695989.EAIaIQobChMIiOmEgYO04gIVj5AYCh2CBAPrEAAYASAAEgIYQfD_BwE</p>
          <p>
            Verwendungszweck: Dies ist ein klassisches Google Analytics-Cookie und dient dem Erfassen verschiedener
            Handlungen auf unserer Webseite.
          </p>
          <p>Ablaufdatum: nach 3 Monaten</p>
          <p>
            Anmerkung: Das Cookie _gac scheint nur in Verbindung mit Google Analytics auf. Die oben angeführte
            Aufzählung hat keinen Anspruch auf Vollständigkeit, da Google für analytische Auswertung immer wieder auch
            andere Cookies verwendet.
          </p>
          <p>
            Sobald Sie eine Aktion auf unserer Webseite abschließen, erkennt Google das Cookie und speichert Ihre
            Handlung als sogenannte Conversion. Solange Sie auf unserer Webseite surfen und das Cookie noch nicht
            abgelaufen ist, erkennen wir und Google, dass Sie über unsere Google-Ads-Anzeige zu uns gefunden haben. Das
            Cookie wird ausgelesen und mit den Conversion-Daten zurück an Google Ads gesendet. Es ist auch möglich, dass
            noch andere Cookies zur Messung von Conversions verwendet werden. Das Conversion-Tracking von Google Ads
            kann mithilfe von Google Analytics noch verfeinert und verbessert werden. Bei Anzeigen, die Google an
            verschiedenen Orten im Web anzeigt, werden unter unserer Domain möglicherweise Cookies mit dem Namen
            „__gads“ oder “_gac” gesetzt. Seit September 2017 werden diverse Kampagneninformationen von analytics.js mit
            dem _gac-Cookie gespeichert. Das Cookie speichert diese Daten, sobald Sie eine unserer Seiten aufrufen, für
            die die automatische Tag-Kennzeichnung von Google Ads eingerichtet wurde. Im Gegensatz zu Cookies, die für
            Google-Domains gesetzt werden, kann Google diese Conversion-Cookies nur lesen, wenn Sie sich auf unserer
            Webseite befinden. Wir erheben und erhalten keine personenbezogenen Daten. Wir bekommen von Google einen
            Bericht mit statistischen Auswertungen. So erfahren wir beispielsweise die Gesamtanzahl der User, die unsere
            Anzeige angeklickt haben und wir sehen, welche Werbemaßnahmen gut ankamen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            An dieser Stelle wollen wir darauf hinweisen, dass wir keinen Einfluss darauf haben, wie Google die
            erhobenen Daten weiterverwendet. Laut Google werden die Daten verschlüsselt und auf sicheren Servern
            gespeichert. In den meisten Fällen laufen Conversion-Cookies nach 30 Tagen ab und übermitteln keine
            personenbezogenen Daten. Die Cookies mit dem Namen „Conversion“ und „_gac“ (das in Verbindung mit Google
            Analytics zum Einsatz kommt) haben ein Ablaufdatum von 3 Monaten.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Sie haben die Möglichkeit am Conversion-Tracking von Google Ads nicht teilzunehmen. Wenn Sie das Cookie des
            Google Conversion-Trackings über Ihren Browser deaktivieren, blockieren Sie das Conversion-Tracking. In
            diesem Fall werden Sie in der Statistik des Tracking-Tools nicht berücksichtigt. Sie können die
            Cookie-Einstellungen in Ihrem Browser jederzeit verändern. Bei jedem Browser funktioniert dies etwas anders.
            Hier finden Sie die Anleitung, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie das Cookie erlauben oder nicht. Durch das Herunterladen und Installieren dieses Browser-Plug-ins auf
            <a href="https://support.google.com/ads/answer/7395996" target="_blank" rel="noopener noreferrer"
              >https://support.google.com/ads/answer/7395996</a
            >
            werden ebenfalls alle „Werbecookies“ deaktiviert. Bedenken Sie, dass Sie durch das Deaktivieren dieser
            Cookies nicht die Werbeanzeigen verhindern, sondern nur die personalisierte Werbung.
          </p>
          <p>
            Durch die Zertifizierung für das amerikanische-europäische Datenschutzübereinkommen „Privacy Shield“, muss
            der amerikanische Konzern Google LLC die in der EU geltenden Datenschutzgesetze einhalten. Wenn Sie Näheres
            über den Datenschutz bei Google erfahren möchten, empfehlen wir die allgemeine Datenschutzerklärung von
            Google:
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer"
              >https://policies.google.com/privacy?hl=de</a
            >.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Facebook Datenschutzerklärung</h2>
          <p>
            Wir verwenden auf unserer Webseite ausgewählte Tools von Facebook. Facebook ist ein Social Media Network des
            Unternehmens Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2 Ireland. Mithilfe
            dieser Tools können wir Ihnen und Menschen, die sich für unsere Produkte und Dienstleistungen interessieren,
            das bestmögliche Angebot bieten. Im Folgenden geben wir einen Überblick über die verschiedenen Facebook
            Tools, welche Daten an Facebook gesendet werden und wie Sie diese Daten löschen können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was sind Facebook-Tools?</h3>
          <p>
            Neben vielen anderen Produkten bietet Facebook auch die sogenannten „Facebook Business Tools“ an. Das ist
            die offizielle Bezeichnung von Facebook. Da der Begriff aber kaum bekannt ist, haben wir uns dafür
            entschieden, sie lediglich Facebook-Tools zu nennen. Darunter finden sich unter anderem:
          </p>
          <p>Facebook-Pixel</p>
          <p>soziale Plug-ins (wie z.B der „Gefällt mir“- oder „Teilen“-Button)</p>
          <p>Facebook Login</p>
          <p>Account Kit</p>
          <p>APIs (Programmierschnittstelle)</p>
          <p>SDKs (Sammlung von Programmierwerkzeugen)</p>
          <p>Plattform-Integrationen</p>
          <p>Plugins</p>
          <p>Codes</p>
          <p>Spezifikationen</p>
          <p>Dokumentationen</p>
          <p>Technologien und Dienstleistungen</p>
          <p>
            Durch diese Tools erweitert Facebook Dienstleistungen und hat die Möglichkeit, Informationen über
            User-Aktivitäten außerhalb von Facebook zu erhalten.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Facebook-Tools auf unserer Webseite?</h3>
          <p>
            Wir wollen unsere Dienstleistungen und Produkte nur Menschen zeigen, die sich auch wirklich dafür
            interessieren. Mithilfe von Werbeanzeigen (Facebook-Ads) können wir genau diese Menschen erreichen. Damit
            den Usern passende Werbung gezeigt werden kann, benötigt Facebook allerdings Informationen über die Wünsche
            und Bedürfnisse der Menschen. So werden dem Unternehmen Informationen über das Userverhalten (und
            Kontaktdaten) auf unserer Webseite zur Verfügung gestellt. Dadurch sammelt Facebook bessere User-Daten und
            kann interessierten Menschen die passende Werbung über unsere Produkte bzw. Dienstleistungen anzeigen. Die
            Tools ermöglichen somit maßgeschneiderte Werbekampagnen auf Facebook.
          </p>
          <p>
            Daten über Ihr Verhalten auf unserer Webseite nennt Facebook „Event-Daten“. Diese werden auch für Messungs-
            und Analysedienste verwendet. Facebook kann so in unserem Auftrag „Kampagnenberichte“ über die Wirkung
            unserer Werbekampagnen erstellen. Weiters bekommen wir durch Analysen einen besseren Einblick, wie Sie
            unsere Dienstleistungen, Webseite oder Produkte verwenden. Dadurch optimieren wir mit einigen dieser Tools
            Ihre Nutzererfahrung auf unserer Webseite. Beispielsweise können Sie mit den sozialen Plug-ins Inhalte auf
            unserer Seite direkt auf Facebook teilen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Facebook-Tools gespeichert?</h3>
          <p>
            Durch die Nutzung einzelner Facebook-Tools können personenbezogene Daten (Kundendaten) an Facebook gesendet
            werden. Abhängig von den benutzten Tools können Kundendaten wie Name, Adresse, Telefonnummer und IP-Adresse
            versandt werden.
          </p>
          <p>
            Facebook verwendet diese Informationen, um die Daten mit den Daten, die es selbst von Ihnen hat (sofern Sie
            Facebook-Mitglied sind) abzugleichen. Bevor Kundendaten an Facebook übermittelt werden, erfolgt ein
            sogenanntes „Hashing“. Das bedeutet, dass ein beliebig großer Datensatz in eine Zeichenkette transformiert
            wird. Dies dient auch der Verschlüsselung von Daten.
          </p>
          <p>
            Neben den Kontaktdaten werden auch „Event-Daten“ übermittelt. Unter „Event-Daten“ sind jene Informationen
            gemeint, die wir über Sie auf unserer Webseite erhalten. Zum Beispiel, welche Unterseiten Sie besuchen oder
            welche Produkte Sie bei uns kaufen. Facebook teilt die erhaltenen Informationen nicht mit Drittanbietern
            (wie beispielsweise Werbetreibende), außer das Unternehmen hat eine explizite Genehmigung oder ist rechtlich
            dazu verpflichtet. „Event-Daten“ können auch mit Kontaktdaten verbunden werden. Dadurch kann Facebook
            bessere personalisierte Werbung anbieten. Nach dem bereits erwähnten Abgleichungsprozess löscht Facebook die
            Kontaktdaten wieder.
          </p>
          <p>
            Um Werbeanzeigen optimiert ausliefern zu können, verwendet Facebook die Event-Daten nur, wenn diese mit
            anderen Daten (die auf andere Weise von Facebook erfasst wurden) zusammengefasst wurden. Diese Event-Daten
            nützt Facebook auch für Sicherheits-, Schutz-, Entwicklungs- und Forschungszwecke. Viele dieser Daten werden
            über Cookies zu Facebook übertragen. Cookies sind kleine Text-Dateien, die zum Speichern von Daten bzw.
            Informationen in Browsern verwendet werden. Je nach verwendeten Tools und abhängig davon, ob Sie
            Facebook-Mitglied sind, werden unterschiedlich viele Cookies in Ihrem Browser angelegt. In den
            Beschreibungen der einzelnen Facebook Tools gehen wir näher auf einzelne Facebook-Cookies ein. Allgemeine
            Informationen über die Verwendung von Facebook-Cookies erfahren Sie auch auf
            <a href="https://www.facebook.com/policies/cookies" target="_blank" rel="noopener noreferrer"
              >https://www.facebook.com/policies/cookies</a
            >.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Grundsätzlich speichert Facebook Daten bis sie nicht mehr für die eigenen Dienste und Facebook-Produkte
            benötigt werden. Facebook hat auf der ganzen Welt Server verteilt, wo seine Daten gespeichert werden.
            Kundendaten werden allerdings, nachdem sie mit den eigenen Userdaten abgeglichen wurden, innerhalb von 48
            Stunden gelöscht.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Entsprechend der Datenschutz Grundverordnung haben Sie das Recht auf Auskunft, Berichtigung, Übertragbarkeit
            und Löschung Ihrer Daten.
          </p>
          <p>
            Eine komplette Löschung der Daten erfolgt nur, wenn Sie Ihr Facebook-Konto vollständig löschen. Und so
            funktioniert das Löschen Ihres Facebook-Kontos:
          </p>
          <p>1) Klicken Sie rechts bei Facebook auf Einstellungen.</p>
          <p>2) Anschließend klicken Sie in der linken Spalte auf „Deine Facebook-Informationen“.</p>
          <p>3) Nun klicken Sie „Deaktivierung und Löschung“.</p>
          <p>4) Wählen Sie jetzt „Konto löschen“ und klicken Sie dann auf „Weiter und Konto löschen“</p>
          <p>5) Geben Sie nun Ihr Passwort ein, klicken Sie auf „Weiter“ und dann auf „Konto löschen“</p>
          <p>
            Die Speicherung der Daten, die Facebook über unsere Seite erhält, erfolgt unter anderem über Cookies (z.B.
            bei sozialen Plugins). In Ihrem Browser können Sie einzelne oder alle Cookies deaktivieren, löschen oder
            verwalten. Je nach dem welchen Browser Sie verwenden, funktioniert dies auf unterschiedliche Art und Weise.
            Die folgenden Anleitungen zeigen, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie es erlauben oder nicht.
          </p>
          <p>
            Facebook ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework, wodurch der korrekte und sichere
            Datentransfer persönlicher Daten geregelt wird. Mehr Informationen dazu finden Sie auf
            <a
              href="https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC</a
            >. Wir hoffen wir haben Ihnen die wichtigsten Informationen über die Nutzung und Datenverarbeitung durch die
            Facebook-Tools nähergebracht. Wenn Sie mehr darüber erfahren wollen, wie Facebook Ihre Daten verwendet,
            empfehlen wir Ihnen die Datenrichtlinien auf
            <a href="https://www.facebook.com/about/privacy/update" target="_blank" rel="noopener noreferrer"
              >https://www.facebook.com/about/privacy/update</a
            >.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Facebook Soziale Plug-ins Datenschutzerklärung</h3>
          <p>
            Auf unserer Webseite sind sogenannte soziale Plug-ins des Unternehmens Facebook Inc. eingebaut. Sie erkennen
            diese Buttons am klassischen Facebook-Logo, wie dem „Gefällt mir“-Button (die Hand mit erhobenem Daumen)
            oder an einer eindeutigen „Facebook Plug-in“-Kennzeichnung. Ein soziales Plug-in ist ein kleiner Teil von
            Facebook, der in unsere Seite integriert ist. Jedes Plug-in hat eine eigene Funktion. Die am meisten
            verwendeten Funktionen sind die bekannten „Gefällt mir“- und „Teilen“-Buttons.
          </p>
          <p>Folgende soziale Plug-ins werden von Facebook angeboten:</p>
          <p>„Speichern“-Button</p>
          <p>„Gefällt mir“-Button, Teilen, Senden und Zitat</p>
          <p>Seiten-Plug-in</p>
          <p>Kommentare</p>
          <p>Messenger-Plug-in</p>
          <p>Eingebettete Beiträge und Videoplayer</p>
          <p>Gruppen-Plug-in</p>
          <p>
            Auf
            <a href="https://developers.facebook.com/docs/plugins" target="_blank" rel="noopener noreferrer"
              >https://developers.facebook.com/docs/plugins</a
            >
            erhalten Sie nähere Informationen, wie die einzelnen Plug-ins verwendet werden. Wir nützen die sozialen
            Plug-ins einerseits, um Ihnen ein besseres Usererlebnis auf unserer Seite zu bieten, andererseits weil
            Facebook dadurch unsere Werbeanzeigen optimieren kann.
          </p>
          <p>
            Sofern Sie ein Facebook-Konto haben oder facebook.com schon mal besucht haben, hat Facebook bereits
            mindestens ein Cookie in Ihrem Browser gesetzt. In diesem Fall sendet Ihr Browser über dieses Cookie
            Informationen an Facebook, sobald Sie unsere Seite besuchen bzw. mit sozialen Plug-ins (z.B. dem „Gefällt
            mir“-Button) interagieren.
          </p>
          <p>
            Die erhaltenen Informationen werden innerhalb von 90 Tagen wieder gelöscht bzw. anonymisiert. Laut Facebook
            gehören zu diesen Daten Ihre IP-Adresse, welche Webseite Sie besucht haben, das Datum, die Uhrzeit und
            weitere Informationen, die Ihren Browser betreffen.
          </p>
          <p>
            Um zu verhindern, dass Facebook während Ihres Besuches auf unserer Webseite viele Daten sammelt und mit den
            Facebook-Daten verbindet, müssen Sie sich während des Webseitenbesuchs von Facebook abmelden (ausloggen).
          </p>
          <p>
            Falls Sie bei Facebook nicht angemeldet sind oder kein Facebook-Konto besitzen, sendet Ihr Browser weniger
            Informationen an Facebook, weil Sie weniger Facebook-Cookies haben. Dennoch können Daten wie beispielsweise
            Ihre IP-Adresse oder welche Webseite Sie besuchen an Facebook übertragen werden. Wir möchten noch
            ausdrücklich darauf hinweisen, dass wir über die genauen Inhalte der Daten nicht exakt Bescheid wissen. Wir
            versuchen aber Sie nach unserem aktuellen Kenntnisstand so gut als möglich über die Datenverarbeitung
            aufzuklären. Wie Facebook die Daten nutzt, können Sie auch in den Datenrichtline des Unternehmens unter
            <a href="https://www.facebook.com/about/privacy/update" target="_blank" rel="noopener noreferrer"
              >https://www.facebook.com/about/privacy/update</a
            >
            nachlesen.
          </p>
          <p>
            Folgende Cookies werden in Ihrem Browser mindestens gesetzt, wenn Sie eine Webseite mit sozialen Plug-ins
            von Facebook besuchen:
          </p>
          <p>Name: dpr</p>
          <p>Wert: keine Angabe</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, damit die sozialen Plug-ins auf unserer Webseite
            funktionieren.
          </p>
          <p>Ablaufdatum: nach Sitzungsende</p>
          <p>Name: fr</p>
          <p>Wert: 0jieyh4221128197c2GnlufEJ9..Bde09j…1.0.Bde09j</p>
          <p>Verwendungszweck: Auch das Cookie ist nötig, dass die Plug-ins einwandfrei funktionieren.</p>
          <p>Ablaufdatum:: nach 3 Monaten</p>
          <p>Anmerkung: Diese Cookies wurden nach einem Test gesetzt, auch wenn Sie nicht Facebook-Mitglied sind.</p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre Einstellungen für Werbeanzeigen unter
            <a
              href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen</a
            >
            selbst verändern. Falls Sie kein Facebook-User sind, können Sie auf
            <a href="http://www.youronlinechoices.com/de/praferenzmanagement/" target="_blank" rel="noopener noreferrer"
              >http://www.youronlinechoices.com/de/praferenzmanagement/</a
            >
            grundsätzlich Ihre nutzungsbasierte Online-Werbung verwalten. Dort haben Sie die Möglichkeit, Anbieter zu
            deaktivieren bzw. zu aktivieren.
          </p>
          <p>
            Wenn Sie mehr über den Datenschutz von Facebook erfahren wollen, empfehlen wir Ihnen die eigenen
            Datenrichtlinien des Unternehmens auf
            <a href="https://www.facebook.com/policy.php" target="_blank" rel="noopener noreferrer"
              >https://www.facebook.com/policy.php</a
            >.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Facebook Login Datenschutzerklärung</h3>
          <p>
            Wir haben auf unserer Seite das praktische Facebook Login integriert. So können Sie sich bei uns ganz
            einfach mit Ihrem Facebook-Konto einloggen, ohne ein weiteres Benutzerkonto anlegen zu müssen. Wenn Sie sich
            entscheiden, Ihre Registrierung über das Facebook Login zu machen, werden Sie auf das Social Media Network
            Facebook weitergeleitet. Dort erfolgt die Anmeldung über Ihre Facebook Nutzerdaten. Durch dieses
            Login-Verfahren werden Daten über Sie bzw. Ihr Userverhalten gespeichert und an Facebook übermittelt.
          </p>
          <p>
            Um die Daten zu speichern, benutzt Facebook verschiedene Cookies. Im Folgenden zeigen wir Ihnen die
            wichtigsten Cookies, die in Ihrem Browser gesetzt werden bzw. schon bestehen, wenn Sie sich über das
            Facebook Login auf unserer Seite anmelden:
          </p>
          <p>Name: fr</p>
          <p>Wert: 0jieyh4c2GnlufEJ9..Bde09j…1.0.Bde09j</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, damit das soziale Plugin auf unserer Webseite bestmöglich
            funktioniert.
          </p>
          <p>Ablaufdatum: nach 3 Monaten</p>
          <p>Name: datr</p>
          <p>Wert: 4Jh7XUA2221128197SEmPsSfzCOO4JFFl</p>
          <p>
            Verwendungszweck: Facebook setzt das „datr“-Cookie, wenn ein Webbrowser auf
            <a href="http://facebook.com/">facebook.com</a> zugreift, und das Cookie hilft, Anmeldeaktivitäten zu
            identifizieren und die Benutzer zu schützen.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: _js_datr</p>
          <p>Wert: deleted</p>
          <p>
            Verwendungszweck: Dieses Session-Cookie setzt Facebook zu Trackingzwecken, auch wenn Sie kein Facebook-Konto
            haben oder ausgeloggt sind.
          </p>
          <p>Ablaufdatum: nach Sitzungsende</p>
          <p>
            Anmerkung: Die angeführten Cookies sind nur eine kleine Auswahl der Cookies, die Facebook zur Verfügung
            stehen. Weitere Cookies sind beispielsweise _ fbp, sb oder wd. Eine vollständige Aufzählung ist nicht
            möglich, da Facebook über eine Vielzahl an Cookies verfügt und diese variabel einsetzt.
          </p>
          <p>
            Der Facebook Login bietet Ihnen einerseits einen schnellen und einfachen Registrierungsprozess, andererseits
            haben wir so die Möglichkeit Daten mit Facebook zu teilen. Dadurch können wir unser Angebot und unsere
            Werbeaktionen besser an Ihre Interessen und Bedürfnisse anpassen. Daten, die wir auf diese Weise von
            Facebook erhalten, sind öffentliche Daten wie
          </p>
          <p>Ihr Facebook-Name</p>
          <p>Ihr Profilbild</p>
          <p>eine hinterlegte E-Mail-Adresse</p>
          <p>Freundeslisten</p>
          <p>Buttons-Angaben (z.B. „Gefällt mir“-Button)</p>
          <p>Geburtstagsdatum</p>
          <p>Sprache</p>
          <p>Wohnort</p>
          <p>
            Im Gegenzug stellen wir Facebook Informationen über Ihre Aktivitäten auf unserer Webseite bereit. Das sind
            unter anderem Informationen über Ihr verwendetes Endgerät, welche Unterseiten Sie bei uns besuchen oder
            welche Produkte Sie bei uns erworben haben.
          </p>
          <p>
            Durch die Verwendung von Facebook Login willigen Sie der Datenverarbeitung ein. Sie können diese
            Vereinbarung jederzeit widerrufen. Wenn Sie mehr Informationen über die Datenverarbeitung durch Facebook
            erfahren wollen, empfehlen wir Ihnen die Facebook-Datenschutzerklärung unter
            <a href="https://de-de.facebook.com/policy.php" target="_blank" rel="noopener noreferrer"
              >https://de-de.facebook.com/policy.php</a
            >.
          </p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre Einstellungen für Werbeanzeigen unter
            <a
              href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen</a
            >
            selbst verändern.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Instagram Datenschutzerklärung</h2>
          <p>
            Wir haben auf unserer Webseite Funktionen von Instagram eingebaut. Instagram ist eine Social Media Plattform
            des Unternehmens Instagram LLC, 1601 Willow Rd, Menlo Park CA 94025, USA. Instagram ist seit 2012 ein
            Tochterunternehmen von Facebook Inc. und gehört zu den Facebook-Produkten. Das Einbetten von
            Instagram-Inhalten auf unserer Webseite nennt man Embedding. Dadurch können wir Ihnen Inhalte wie Buttons,
            Fotos oder Videos von Instagram direkt auf unserer Webseite zeigen. Wenn Sie Webseiten unserer Webpräsenz
            aufrufen, die eine Instagram-Funktion integriert haben, werden Daten an Instagram übermittelt, gespeichert
            und verarbeitet. Instagram verwendet dieselben Systeme und Technologien wie Facebook. Ihre Daten werden
            somit über alle Facebook-Firmen hinweg verarbeitet.
          </p>
          <p>
            Im Folgenden wollen wir Ihnen einen genaueren Einblick geben, warum Instagram Daten sammelt, um welche Daten
            es sich handelt und wie Sie die Datenverarbeitung weitgehend kontrollieren können. Da Instagram zu Facebook
            Inc. gehört, beziehen wir unsere Informationen einerseits von den Instagram-Richtlinien, andererseits
            allerdings auch von den Facebook-Datenrichtlinien selbst.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist Instagram?</h3>
          <p>
            Instagram ist eines der bekanntesten Social Media Netzwerken weltweit. Instagram kombiniert die Vorteile
            eines Blogs mit den Vorteilen von audiovisuellen Plattformen wie YouTube oder Vimeo. Sie können auf „Insta“
            (wie viele der User die Plattform salopp nennen) Fotos und kurze Videos hochladen, mit verschiedenen Filtern
            bearbeiten und auch in anderen sozialen Netzwerken verbreiten. Und wenn Sie selbst nicht aktiv sein wollen,
            können Sie auch nur anderen interessante Users folgen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir Instagram auf unserer Webseite?</h3>
          <p>
            Instagram ist jene Social Media Plattform, die in den letzten Jahren so richtig durch die Decke ging. Und
            natürlich haben auch wir auf diesen Boom reagiert. Wir wollen, dass Sie sich auf unserer Webseite so wohl
            wie möglich fühlen. Darum ist für uns eine abwechslungsreiche Aufbereitung unserer Inhalte
            selbstverständlich. Durch die eingebetteten Instagram-Funktionen können wir unseren Content mit hilfreichen,
            lustigen oder spannenden Inhalten aus der Instagram-Welt bereichern. Da Instagram eine Tochtergesellschaft
            von Facebook ist, können uns die erhobenen Daten auch für personalisierte Werbung auf Facebook dienlich
            sein. So bekommen unsere Werbeanzeigen nur Menschen, die sich wirklich für unsere Produkte oder
            Dienstleistungen interessieren.
          </p>
          <p>
            Instagram nützt die gesammelten Daten auch zu Messungs- und Analysezwecken. Wir bekommen zusammengefasste
            Statistiken und so mehr Einblick über Ihre Wünsche und Interessen. Wichtig ist zu erwähnen, dass diese
            Berichte Sie nicht persönlich identifizieren.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von Instagram gespeichert?</h3>
          <p>
            Wenn Sie auf eine unserer Seiten stoßen, die Instagram-Funktionen (wie Instagrambilder oder Plug-ins)
            eingebaut haben, setzt sich Ihr Browser automatisch mit den Servern von Instagram in Verbindung. Dabei
            werden Daten an Instagram versandt, gespeichert und verarbeitet. Und zwar unabhängig, ob Sie ein
            Instagram-Konto haben oder nicht. Dazu zählen Informationen über unserer Webseite, über Ihren Computer, über
            getätigte Käufe, über Werbeanzeigen, die Sie sehen und wie Sie unser Angebot nutzen. Weiters werden auch
            Datum und Uhrzeit Ihrer Interaktion mit Instagram gespeichert. Wenn Sie ein Instagram-Konto haben bzw.
            eingeloggt sind, speichert Instagram deutlich mehr Daten über Sie.
          </p>
          <p>
            Facebook unterscheidet zwischen Kundendaten und Eventdaten. Wir gehen davon aus, dass dies bei Instagram
            genau so der Fall ist. Kundendaten sind zum Beispiel Name, Adresse, Telefonnummer und IP-Adresse. Diese
            Kundendaten werden erst an Instagram übermittelt werden, wenn Sie zuvor „gehasht“ wurden. Hashing meint, ein
            Datensatz wird in eine Zeichenkette verwandelt. Dadurch kann man die Kontaktdaten verschlüsseln. Zudem
            werden auch die oben genannten „Event-Daten“ übermittelt. Unter „Event-Daten“ versteht Facebook – und
            folglich auch Instagram – Daten über Ihr Userverhalten. Es kann auch vorkommen, dass Kontaktdaten mit
            Event-Daten kombiniert werden. Die erhobenen Kontaktdaten werden mit den Daten, die Instagram bereits von
            Ihnen hat, abgeglichen.
          </p>
          <p>
            Über kleine Text-Dateien (Cookies), die meist in Ihrem Browser gesetzt werden, werden die gesammelten Daten
            an Facebook übermittelt. Je nach verwendeten Instagram-Funktionen und ob Sie selbst ein Instagram-Konto
            haben, werden unterschiedlich viele Daten gespeichert.
          </p>
          <p>
            Wir gehen davon aus, dass bei Instagram die Datenverarbeitung gleich funktioniert wie bei Facebook. Das
            bedeutet: wenn Sie ein Instagram-Konto haben oder www.instagram.com besucht haben, hat Instagram zumindest
            ein Cookie gesetzt. Wenn das der Fall ist, sendet Ihr Browser über das Cookie Infos an Instagram, sobald Sie
            mit einer Instagram-Funktion in Berührung kommen. Spätestens nach 90 Tagen (nach Abgleichung) werden diese
            Daten wieder gelöscht bzw. anonymisiert. Obwohl wir uns intensiv mit der Datenverarbeitung von Instagram
            beschäftigt haben, können wir nicht ganz genau sagen, welche Daten Instagram exakt sammelt und speichert.
          </p>
          <p>
            Im Folgenden zeigen wir Ihnen Cookies, die in Ihrem Browser mindestens gesetzt werden, wenn Sie auf eine
            Instagram-Funktion (wie z.B. Button oder ein Insta-Bild) klicken. Bei unserem Test gehen wir davon aus, dass
            Sie kein Instagram-Konto haben. Wenn Sie bei Instagram eingeloggt sind, werden natürlich deutlich mehr
            Cookies in Ihrem Browser gesetzt.
          </p>
          <p>Diese Cookies wurden bei unserem Test verwendet:</p>
          <p>Name: csrftoken</p>
          <p>Wert: „“</p>
          <p>
            Verwendungszweck: Dieses Cookie wird mit hoher Wahrscheinlichkeit aus Sicherheitsgründen gesetzt, um
            Fälschungen von Anfragen zu verhindern. Genauer konnten wir das allerdings nicht in Erfahrung bringen.
          </p>
          <p>Ablaufdatum: nach einem Jahr</p>
          <p>Name: mid</p>
          <p>Wert: „“</p>
          <p>
            Verwendungszweck: Instagram setzt dieses Cookie, um die eigenen Dienstleistungen und Angebote in und
            außerhalb von Instagram zu optimieren. Das Cookie legt eine eindeutige User-ID fest.
          </p>
          <p>Ablaufdatum: nach Ende der Sitzung</p>
          <p>Name: fbsr_221128197124024</p>
          <p>Wert: keine Angaben</p>
          <p>Verwendungszweck: Dieses Cookie speichert die Log-in-Anfrage für User der Instagram-App.</p>
          <p>Ablaufdatum: nach Ende der Sitzung</p>
          <p>Name: rur</p>
          <p>Wert: ATN</p>
          <p>
            Verwendungszweck: Dabei handelt es sich um ein Instagram-Cookie, das die Funktionalität auf Instagram
            gewährleistet.
          </p>
          <p>Ablaufdatum: nach Ende der Sitzung</p>
          <p>Name: urlgen</p>
          <p>Wert: „{„194.96.75.33″: 1901}:1iEtYv:Y833k2_UjKvXgYe221128197“</p>
          <p>Verwendungszweck: Dieses Cookie dient den Marketingzwecken von Instagram.</p>
          <p>Ablaufdatum: nach Ende der Sitzung</p>
          <p>
            Anmerkung: Wir können hier keinen Vollständigkeitsanspruch erheben. Welche Cookies im individuellen Fall
            gesetzt werden, hängt von den eingebetteten Funktionen und Ihrer Verwendung von Instagram ab.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Instagram teilt die erhaltenen Informationen zwischen den Facebook-Unternehmen mit externen Partnern und mit
            Personen, mit denen Sie sich weltweit verbinden. Die Datenverarbeitung erfolgt unter Einhaltung der eigenen
            Datenrichtlinie. Ihre Daten sind, unter anderem aus Sicherheitsgründen, auf den Facebook-Servern auf der
            ganzen Welt verteilt. Die meisten dieser Server stehen in den USA.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Dank der Datenschutz Grundverordnung haben Sie das Recht auf Auskunft, Übertragbarkeit, Berichtigung und
            Löschung Ihrer Daten. In den Instagram-Einstellungen können Sie Ihre Daten verwalten. Wenn Sie Ihre Daten
            auf Instagram völlig löschen wollen, müssen Sie Ihr Instagram-Konto dauerhaft löschen.
          </p>
          <p>Und so funktioniert die Löschung des Instagram-Kontos:</p>
          <p>
            Öffnen Sie zuerst die Instagram-App. Auf Ihrer Profilseite gehen Sie nach unten und klicken Sie auf
            „Hilfebereich“. Jetzt kommen Sie auf die Webseite des Unternehmens. Klicken Sie auf der Webseite auf
            „Verwalten des Kontos“ und dann auf „Dein Konto löschen“.
          </p>
          <p>
            Wenn Sie Ihr Konto ganz löschen, löscht Instagram Posts wie beispielsweise Ihre Fotos und Status-Updates.
            Informationen, die andere Personen über Sie geteilt haben, gehören nicht zu Ihrem Konto und werden folglich
            nicht gelöscht.
          </p>
          <p>
            Wie bereits oben erwähnt, speichert Instagram Ihre Daten in erster Linie über Cookies. Diese Cookies können
            Sie in Ihrem Browser verwalten, deaktivieren oder löschen. Abhängig von Ihrem Browser funktioniert die
            Verwaltung immer ein bisschen anders. Hier zeigen wir Ihnen die Anleitungen der wichtigsten Browser.
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Sie können auch grundsätzlich Ihren Browser so einrichten, dass Sie immer informiert werden, wenn ein Cookie
            gesetzt werden soll. Dann können Sie immer individuell entscheiden, ob Sie das Cookie zulassen wollen oder
            nicht.
          </p>
          <p>
            Instagram ist ein Tochterunternehmen von Facebook Inc. und Facebook ist aktiver Teilnehmer beim EU-U.S.
            Privacy Shield Framework. Dieses Framework stellt eine korrekte Datenübertragung zwischen den USA und der
            Europäischen Union sicher. Unter
            <a
              href="https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC</a
            >
            erfahren Sie mehr darüber. Wir haben versucht, Ihnen die wichtigsten Informationen über die
            Datenverarbeitung durch Instagram näherzubringen. Auf
            <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer"
              >https://help.instagram.com/519522125107875</a
            >
            können Sie sich noch näher mit den Datenrichtlinien von Instagram auseinandersetzen.
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Sendinblue Datenschutzerklärung</h2>
          <p>
            Sie können sich auf unserer Website kostenlos für unseren Newsletter anmelden. Damit das auch funktioniert,
            verwenden wir für unseren Newsletter den E-Mail-Versanddienst Sendinblue. Das ist ein Service des deutschen
            Unternehmens Sendinblue GmbH, Köpenicker Str. 126, 10179 Berlin.
          </p>
          <p>
            Uns freut es natürlich sehr, wenn Sie sich für unseren Newsletter anmelden. So können wir Ihnen immer
            aktuell und aus erster Hand mitteilen, was sich in unserem Unternehmen gerade so abspielt. Sie sollten aber
            wissen, dass beim Anmeldevorgang zum Newsletter alle Daten, die Sie eingeben (wie zum Beispiel Ihre
            E-Mailadresse oder Ihr Vor- und Nachname) auf unserem Server und bei Sendinblue gespeichert und verwaltet
            werden. Dabei handelt es sich auch um personenbezogene Daten. So wird beispielsweise neben der Uhrzeit und
            dem Datum der Anmeldung auch Ihre IP-Adresse gespeichert. Im Verlauf der Anmeldung willigen Sie auch ein,
            dass wir Ihnen den Newsletter senden können und es wird weiters auf diese Datenschutzerklärung hingewiesen.
          </p>
          <p>
            Der Newsletter-Dienst bietet uns auch hilfreiche Analysemöglichkeiten. Das heißt, wenn wir einen Newsletter
            verschicken, erfahren wir beispielsweise ob und wann der Newsletter von Ihnen geöffnet wurde. Auch ob und
            auf welchen Link Sie im Newsletter klicken, wird von der Software erkannt und aufgezeichnet. Diese
            Informationen helfen enorm, unser Service an Ihre Wünsche und Anliegen anzupassen und zu optimieren.
            Schließlich wollen wir natürlich Ihnen die bestmögliche Dienstleistung bieten. Neben den oben bereits
            erwähnten Daten werden also auch solche Daten über Ihre Userverhalten gespeichert.
          </p>
          <p>
            Die von Ihnen durchgeführte Einwilligung dieser Datenverarbeitung können Sie jederzeit widerrufen. Zum
            Beispiel, wenn Sie direkt im Newsletter auf den Abmeldelink klicken. Nach der Abmeldung werden die
            personenbezogenen Daten von unserem Server und von den Sendinblue-Servern, die in Deutschland angesiedelt
            sind, gelöscht. Sie haben ein Recht auf unentgeltliche Auskunft über Ihre gespeicherten Daten und
            gegebenenfalls auch ein Recht auf Löschung, Sperrung oder Berichtigung.
          </p>
          <p>
            Wenn sie nähere Informationen über die Datenverarbeitung einholen wollen, empfehlen wir Ihnen die
            Datenschutzrichtlinie des Unternehmens unter
            <a href="https://de.sendinblue.com/legal/privacypolicy/" target="_blank" rel="noopener noreferrer"
              >https://de.sendinblue.com/legal/privacypolicy/</a
            >
            und zudem auch noch folgende Informationsseite unter
            <a
              href="https://de.sendinblue.com/informationen-newsletter-empfaenger/"
              target="_blank"
              rel="noopener noreferrer"
              >https://de.sendinblue.com/informationen-newsletter-empfaenger/</a
            >
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">YouTube Datenschutzerklärung</h2>
          <p>
            Wir haben auf unserer Website YouTube-Videos eingebaut. So können wir Ihnen interessante Videos direkt auf
            unserer Seite präsentieren. YouTube ist ein Videoportal, das seit 2006 eine Tochterfirma von Google ist.
            Betrieben wird das Videoportal durch YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie auf
            unserer Website eine Seite aufrufen, die ein YouTube-Video eingebettet hat, verbindet sich Ihr Browser
            automatisch mit den Servern von YouTube bzw. Google. Dabei werden (je nach Einstellungen) verschiedene Daten
            übertragen. Für die gesamte Datenverarbeitung im europäischen Raum ist Google Ireland Limited (Gordon House,
            Barrow Street Dublin 4, Irland) verantwortlich.
          </p>
          <p>
            Im Folgenden wollen wir Ihnen genauer erklären, welche Daten verarbeitet werden, warum wir YouTube-Videos
            eingebunden haben und wie Sie Ihre Daten verwalten oder löschen können.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Was ist YouTube?</h3>
          <p>
            Auf YouTube können die User kostenlos Videos ansehen, bewerten, kommentieren und selbst hochladen. Über die
            letzten Jahre wurde YouTube zu einem der wichtigsten Social-Media-Kanäle weltweit. Damit wir Videos auf
            unserer Webseite anzeigen können, stellt YouTube einen Codeausschnitt zur Verfügung, den wir auf unserer
            Seite eingebaut haben.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Warum verwenden wir YouTube-Videos auf unserer Webseite?</h3>
          <p>
            YouTube ist die Videoplattform mit den meisten Besuchern und dem besten Content. Wir sind bemüht, Ihnen die
            bestmögliche User-Erfahrung auf unserer Webseite zu bieten. Und natürlich dürfen interessante Videos dabei
            nicht fehlen. Mithilfe unserer eingebetteten Videos stellen wir Ihnen neben unseren Texten und Bildern
            weiteren hilfreichen Content zur Verfügung. Zudem wird unsere Webseite auf der Google-Suchmaschine durch die
            eingebetteten Videos leichter gefunden. Auch wenn wir über Google Ads Werbeanzeigen schalten, kann Google –
            dank der gesammelten Daten – diese Anzeigen wirklich nur Menschen zeigen, die sich für unsere Angebote
            interessieren.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">Welche Daten werden von YouTube gespeichert?</h3>
          <p>
            Sobald Sie eine unserer Seiten besuchen, die ein YouTube-Video eingebaut hat, setzt YouTube zumindest ein
            Cookie, das Ihre IP-Adresse und unsere URL speichert. Wenn Sie in Ihrem YouTube-Konto eingeloggt sind, kann
            YouTube Ihre Interaktionen auf unserer Webseite meist mithilfe von Cookies Ihrem Profil zuordnen. Dazu
            zählen Daten wie Sitzungsdauer, Absprungrate, ungefährer Standort, technische Informationen wie Browsertyp,
            Bildschirmauflösung oder Ihr Internetanbieter. Weitere Daten können Kontaktdaten, etwaige Bewertungen, das
            Teilen von Inhalten über Social Media oder das Hinzufügen zu Ihren Favoriten auf YouTube sein.
          </p>
          <p>
            Wenn Sie nicht in einem Google-Konto oder einem Youtube-Konto angemeldet sind, speichert Google Daten mit
            einer eindeutigen Kennung, die mit Ihrem Gerät, Browser oder App verknüpft sind. So bleibt beispielsweise
            Ihre bevorzugte Spracheinstellung beibehalten. Aber viele Interaktionsdaten können nicht gespeichert werden,
            da weniger Cookies gesetzt werden.
          </p>
          <p>
            In der folgenden Liste zeigen wir Cookies, die in einem Test im Browser gesetzt wurden. Wir zeigen
            einerseits Cookies, die ohne angemeldetes YouTube-Konto gesetzt werden. Andererseits zeigen wir Cookies, die
            mit angemeldetem Account gesetzt werden. Die Liste kann keinen Vollständigkeitsanspruch erheben, weil die
            Userdaten immer von den Interaktionen auf YouTube abhängen.
          </p>
          <p>Name: YSC</p>
          <p>Wert: b9-CV6ojI5Y221128197-1</p>
          <p>
            Verwendungszweck: Dieses Cookie registriert eine eindeutige ID, um Statistiken des gesehenen Videos zu
            speichern.
          </p>
          <p>Ablaufdatum: nach Sitzungsende</p>
          <p>Name: PREF</p>
          <p>Wert: f1=50000000</p>
          <p>
            Verwendungszweck: Dieses Cookie registriert ebenfalls Ihre eindeutige ID. Google bekommt über PREF
            Statistiken, wie Sie YouTube-Videos auf unserer Webseite verwenden.
          </p>
          <p>Ablaufdatum: nach 8 Monaten</p>
          <p>Name: GPS</p>
          <p>Wert: 1</p>
          <p>
            Verwendungszweck: Dieses Cookie registriert Ihre eindeutige ID auf mobilen Geräten, um den GPS-Standort zu
            tracken.
          </p>
          <p>Ablaufdatum: nach 30 Minuten</p>
          <p>Name: VISITOR_INFO1_LIVE</p>
          <p>Wert: 95Chz8bagyU</p>
          <p>
            Verwendungszweck: Dieses Cookie versucht die Bandbreite des Users auf unseren Webseiten (mit eingebautem
            YouTube-Video) zu schätzen.
          </p>
          <p>Ablaufdatum: nach 8 Monaten</p>
          <p>Weitere Cookies, die gesetzt werden, wenn Sie mit Ihrem YouTube-Konto angemeldet sind:</p>
          <p>Name: APISID</p>
          <p>Wert: zILlvClZSkqGsSwI/AU1aZI6HY7221128197-</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, um ein Profil über Ihre Interessen zu erstellen. Genützt
            werden die Daten für personalisierte Werbeanzeigen.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: CONSENT</p>
          <p>Wert: YES+AT.de+20150628-20-0</p>
          <p>
            Verwendungszweck: Das Cookie speichert den Status der Zustimmung eines Users zur Nutzung unterschiedlicher
            Services von Google. CONSENT dient auch der Sicherheit, um User zu überprüfen und Userdaten vor unbefugten
            Angriffen zu schützen.
          </p>
          <p>Ablaufdatum: nach 19 Jahren</p>
          <p>Name: HSID</p>
          <p>Wert: AcRwpgUik9Dveht0I</p>
          <p>
            Verwendungszweck: Dieses Cookie wird verwendet, um ein Profil über Ihre Interessen zu erstellen. Diese Daten
            helfen personalisierte Werbung anzeigen zu können.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: LOGIN_INFO</p>
          <p>Wert: AFmmF2swRQIhALl6aL…</p>
          <p>Verwendungszweck: In diesem Cookie werden Informationen über Ihre Login-Daten gespeichert.</p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: SAPISID</p>
          <p>Wert: 7oaPxoG-pZsJuuF5/AnUdDUIsJ9iJz2vdM</p>
          <p>
            Verwendungszweck: Dieses Cookie funktioniert, indem es Ihren Browser und Ihr Gerät eindeutig identifiziert.
            Es wird verwendet, um ein Profil über Ihre Interessen zu erstellen.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: SID</p>
          <p>Wert: oQfNKjAsI221128197-</p>
          <p>
            Verwendungszweck: Dieses Cookie speichert Ihre Google-Konto-ID und Ihren letzten Anmeldezeitpunkt in digital
            signierter und verschlüsselter Form.
          </p>
          <p>Ablaufdatum: nach 2 Jahren</p>
          <p>Name: SIDCC</p>
          <p>Wert: AN0-TYuqub2JOcDTyL</p>
          <p>
            Verwendungszweck: Dieses Cookie speichert Informationen, wie Sie die Webseite nutzen und welche Werbung Sie
            vor dem Besuch auf unserer Seite möglicherweise gesehen haben.
          </p>
          <p>Ablaufdatum: nach 3 Monaten</p>
          <h3 class="text-base font-semibold mt-6 mb-2">Wie lange und wo werden die Daten gespeichert?</h3>
          <p>
            Die Daten, die YouTube von Ihnen erhält und verarbeitet werden auf den Google-Servern gespeichert. Die
            meisten dieser Server befinden sich in Amerika. Unter
            <a
              href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.google.com/about/datacenters/inside/locations/?hl=de</a
            >
            sehen Sie genau wo sich die Google-Rechenzentren befinden. Ihre Daten sind auf den Servern verteilt. So sind
            die Daten schneller abrufbar und vor Manipulation besser geschützt.
          </p>
          <p>
            Die erhobenen Daten speichert Google unterschiedlich lang. Manche Daten können Sie jederzeit löschen, andere
            werden automatisch nach einer begrenzten Zeit gelöscht und wieder andere werden von Google über längere Zeit
            gespeichert. Einige Daten (wie Elemente aus „Meine Aktivität“, Fotos oder Dokumente, Produkte), die in Ihrem
            Google-Konto gespeichert sind, bleiben so lange gespeichert, bis Sie sie löschen. Auch wenn Sie nicht in
            einem Google-Konto angemeldet sind, können Sie einige Daten, die mit Ihrem Gerät, Browser oder App verknüpft
            sind, löschen.
          </p>
          <h3 class="text-base font-semibold mt-6 mb-2">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
          </h3>
          <p>
            Grundsätzlich können Sie Daten im Google Konto manuell löschen. Mit der 2019 eingeführten automatischen
            Löschfunktion von Standort- und Aktivitätsdaten werden Informationen abhängig von Ihrer Entscheidung –
            entweder 3 oder 18 Monate gespeichert und dann gelöscht.
          </p>
          <p>
            Unabhängig, ob Sie ein Google-Konto haben oder nicht, können Sie Ihren Browser so konfigurieren, dass
            Cookies von Google gelöscht bzw. deaktiviert werden. Je nachdem welchen Browser Sie verwenden, funktioniert
            dies auf unterschiedliche Art und Weise. Die folgenden Anleitungen zeigen, wie Sie Cookies in Ihrem Browser
            verwalten:
          </p>
          <p class="mt-2">
            <a href="https://support.google.com/chrome/answer/95647?tid=221128197"
              >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
            >
          </p>
          <p>
            <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=221128197"
              >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
            >
          </p>
          <p>
            <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=221128197"
              >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a
            >
          </p>
          <p>
            <a
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=221128197"
              >Internet Explorer: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p class="mb-2">
            <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=221128197"
              >Microsoft Edge: Löschen und Verwalten von Cookies</a
            >
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie
            immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden,
            ob Sie es erlauben oder nicht. Da YouTube ein Tochterunternehmen von Google ist, gibt es eine gemeinsame
            Datenschutzerklärung. Wenn Sie mehr über den Umgang mit Ihren Daten erfahren wollen, empfehlen wir Ihnen die
            Datenschutzerklärung unter
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer"
              >https://policies.google.com/privacy?hl=de</a
            >.
          </p>
          <p>
            Quelle: Erstellt mit dem
            <a href="https://www.firmenwebseiten.at/datenschutz-generator/">Datenschutz Generator</a>
            von <a href="http://firmenwebseiten.at/">firmenwebseiten.at</a> in Kooperation mit
            <a href="https://www.123haus.at/">123haus.at</a>
          </p>
          <h2 class="text-lg font-semibold mt-6 mb-2">Hotjar</h2>
          <p>
            Wir nutzen Hotjar, um die Bedürfnisse unserer Nutzer besser zu verstehen und das Angebot und die Erfahrung
            auf dieser Webseite zu optimieren. Mithilfe der Technologie von Hotjar bekommen wir ein besseres Verständnis
            von den Erfahrungen unserer Nutzer (z.B. wieviel Zeit Nutzer auf welchen Seiten verbringen, welche Links sie
            anklicken, was sie mögen und was nicht usw.) und das hilft uns, unser Angebot am Feedback unserer Nutzer
            auszurichten. Hotjar arbeitet mit Cookies und anderen Technologien, um Daten über das Nutzerverhalten und
            Endgeräte zu erheben, insbesondere IP Adresse des Geräts (wird während Ihrer Website-Nutzung nur in
            anonymisierter Form erfasst und gespeichert), Bildschirmgröße, Gerätetyp (Unique Device Identifiers),
            Informationen über den verwendeten Browser, Standort (nur Land), zur Anzeige unserer Webseite bevorzugte
            Sprache. Hotjar speichert diese Informationen in unserem Auftrag in einem pseudonymisierten Nutzerprofil.
            Hotjar ist es vertraglich verboten, die in unserem Auftrag erhobenen Daten zu verkaufen.
          </p>
          <p>
            Weitere Informationen finden Sie unter dem Abschnitt ‚über Hotjar‘ auf
            <a href="https://help.hotjar.com/hc/de/categories/115001323967-About-Hotjar">Hotjars Hilfe-Seite</a>.
          </p>
        </div>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import MainLayout from "_layouts";

export default {
  components: { MainLayout },
};
</script>
<style scoped>
.prose a {
  text-decoration: underline;
  text-decoration-color: currentColor;
}
.prose p {
  margin-block: 0.5rem;
}
</style>
